import { Injectable, defineInjectable } from '@angular/core';
import { minBy, sumBy, uniqBy, isEqual, maxBy, orderBy, take, unionWith, extend, remove, cloneDeep, floor, sortBy } from 'lodash-es';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class TaxInfo {
    /**
     * @param {?} init
     */
    constructor(init) {
        Object.assign(this, init);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const TaxMode = {
    None: 1,
    TaxOnWinningsExclStake: 2,
    TaxOnStakeAndWinnings: 3,
};
TaxMode[TaxMode.None] = 'None';
TaxMode[TaxMode.TaxOnWinningsExclStake] = 'TaxOnWinningsExclStake';
TaxMode[TaxMode.TaxOnStakeAndWinnings] = 'TaxOnStakeAndWinnings';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
class AbstractFunction {
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TaxResult {
    /**
     * @param {?} init
     */
    constructor(init) {
        this.details = [];
        this.totalTaxed = 0;
        this.totalAfterTax = 0;
        Object.assign(this, init);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const TaxReason = {
    WithholdingTax: 1,
    TurnoverTax: 2,
};
TaxReason[TaxReason.WithholdingTax] = 'WithholdingTax';
TaxReason[TaxReason.TurnoverTax] = 'TurnoverTax';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NoTaxFunction extends AbstractFunction {
    constructor() {
        super(...arguments);
        this.taxMode = TaxMode.None;
    }
    /**
     * @return {?}
     */
    turnoverTaxFunction() {
        return (/**
         * @param {?} taxBrackets
         * @param {?} param
         * @return {?}
         */
        (taxBrackets, param) => {
            return new TaxResult({
                taxReason: TaxReason.TurnoverTax,
                totalAfterTax: param.stake,
                totalTaxed: 0,
                details: []
            });
        });
    }
    /**
     * @return {?}
     */
    withholdingTaxFunction() {
        return (/**
         * @param {?} taxBrackets
         * @param {?} param
         * @return {?}
         */
        (taxBrackets, param) => {
            return new TaxResult({
                taxReason: TaxReason.WithholdingTax,
                totalAfterTax: param.wonAmount,
                totalTaxed: 0,
                details: []
            });
        });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @dynamic
class FunctionRepository {
    constructor() {
        this._withHoldingFuncs = [];
        this._turnoverFuncs = [];
    }
    /**
     * @return {?}
     */
    static get Instance() {
        if (!FunctionRepository._instance) {
            FunctionRepository._instance = new FunctionRepository();
            this.initFunctions(); // Initialize all functions after constructor invocation
        }
        return FunctionRepository._instance;
    }
    /**
     * @private
     * @return {?}
     */
    static initFunctions() {
        /** @type {?} */
        const noTaxFunction = new NoTaxFunction();
        if (!FunctionRepository.Instance.tryAddFunction(noTaxFunction.taxMode, noTaxFunction)) {
            throw new Error(`Failed to instantiate 'No Tax' Functions`);
        }
    }
    /**
     * @param {?} mode
     * @param {?} func
     * @return {?}
     */
    tryAddFunction(mode, func) {
        try {
            this._withHoldingFuncs.push({ key: mode, value: func.withholdingTaxFunction() });
            this._turnoverFuncs.push({ key: mode, value: func.turnoverTaxFunction() });
        }
        catch (e) {
            return false;
        }
        return true;
    }
    /**
     * @param {?} taxMode
     * @return {?}
     */
    calculateWithholdingTax(taxMode) {
        /** @type {?} */
        const funcItem = this._withHoldingFuncs.find((/**
         * @param {?} i
         * @return {?}
         */
        i => i.key === taxMode));
        return funcItem ? funcItem.value : undefined;
    }
    /**
     * @param {?} taxMode
     * @return {?}
     */
    calculateTurnoverTax(taxMode) {
        /** @type {?} */
        const funcItem = this._turnoverFuncs.find((/**
         * @param {?} i
         * @return {?}
         */
        i => i.key === taxMode));
        return funcItem ? funcItem.value : undefined;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NoTaxModule {
    constructor() {
        this.brandID = 1901;
        this.taxBrackets = [];
        this.taxMode = TaxMode.None;
    }
    /**
     * @param {?} param
     * @return {?}
     */
    calculateTurnoverTax(param) {
        return FunctionRepository.Instance.calculateTurnoverTax(this.taxMode)(this.taxBrackets, param);
    }
    /**
     * @param {?} param
     * @return {?}
     */
    calculateWithholdingTax(param) {
        return FunctionRepository.Instance.calculateWithholdingTax(this.taxMode)(this.taxBrackets, param);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class VictoryTaxModule {
    constructor() {
        this.brandID = 1001;
        this.taxBrackets = [];
        this.taxMode = TaxMode.None;
    }
    /**
     * @param {?} param
     * @return {?}
     */
    calculateTurnoverTax(param) {
        return FunctionRepository.Instance.calculateTurnoverTax(this.taxMode)(this.taxBrackets, param);
    }
    /**
     * @param {?} param
     * @return {?}
     */
    calculateWithholdingTax(param) {
        return FunctionRepository.Instance.calculateWithholdingTax(this.taxMode)(this.taxBrackets, param);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @dynamic
class TaxModuleSelector {
    constructor() {
        this._taxModules = [];
    }
    /**
     * @return {?}
     */
    static get Instance() {
        if (!TaxModuleSelector._instance) {
            TaxModuleSelector._instance = new TaxModuleSelector();
            this.initModules(); // Initialize all modules after constructor invocation
        }
        return TaxModuleSelector._instance;
    }
    /**
     * @private
     * @return {?}
     */
    static initModules() {
        if (!TaxModuleSelector.Instance.tryAddModule(1901, new NoTaxModule())) {
            throw new Error(`Failed to instantiate 'No Tax' Module`);
        }
        if (!TaxModuleSelector.Instance.tryAddModule(1001, new VictoryTaxModule())) {
            throw new Error(`Failed to instantiate 'Victory Tax' Module`);
        }
    }
    /**
     * @param {?} brandID
     * @param {?} taxModule
     * @return {?}
     */
    tryAddModule(brandID, taxModule) {
        try {
            this._taxModules.push({ key: brandID, value: taxModule });
        }
        catch (e) {
            return false;
        }
        return true;
    }
    /**
     * @param {?} brandID
     * @return {?}
     */
    getModule(brandID) {
        /** @type {?} */
        const moduleItem = this._taxModules.find((/**
         * @param {?} i
         * @return {?}
         */
        i => i.key === brandID));
        return moduleItem ? moduleItem.value : undefined;
    }
    /**
     * @return {?}
     */
    getTaxModes() {
        return this._taxModules.map((/**
         * @param {?} x
         * @return {?}
         */
        x => new TaxInfo({ brandID: x.value.brandID, taxMode: x.value.taxMode })));
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// @dynamic
class TaxationService {
    /**
     * @return {?}
     */
    static get Instance() {
        if (!TaxationService._instance) {
            TaxationService._instance = new TaxationService();
        }
        return TaxationService._instance;
    }
    /**
     * @param {?} brandID
     * @return {?}
     */
    getModuleByBrandID(brandID) {
        return TaxModuleSelector.Instance.getModule(brandID);
    }
    /**
     * @param {?} brandID
     * @param {?} param
     * @return {?}
     */
    calculateTurnoverTaxByBrandID(brandID, param) {
        /** @type {?} */
        const brandModule = this.getModuleByBrandID(brandID);
        return brandModule ? brandModule.calculateTurnoverTax(param) : new TaxResult({});
    }
    /**
     * @param {?} brandID
     * @param {?} param
     * @return {?}
     */
    calculateWithholdingTaxByBrandID(brandID, param) {
        /** @type {?} */
        const brandModule = this.getModuleByBrandID(brandID);
        return brandModule ? brandModule.calculateWithholdingTax(param) : new TaxResult({});
    }
    /**
     * @return {?}
     */
    getTaxModes() {
        return TaxModuleSelector.Instance.getTaxModes();
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TaxConfiguration {
    /**
     * @param {?=} init
     */
    constructor(init) {
        this.isVirtual = false;
        this.twoDecimalPrecision = false;
        Object.assign(this, init);
    }
}
class TurnoverTaxParameter {
    /**
     * @param {?} date
     * @param {?} stake
     * @param {?=} taxConfiguration
     */
    constructor(date, stake, taxConfiguration) {
        this.date = date;
        this.stake = stake;
        this.taxConfiguration = taxConfiguration || new TaxConfiguration();
    }
}
class WithholdingTaxParameter {
    /**
     * @param {?} date
     * @param {?} wonAmount
     * @param {?} stake
     * @param {?=} taxConfiguration
     */
    constructor(date, wonAmount, stake, taxConfiguration) {
        this.date = date;
        this.wonAmount = wonAmount;
        this.stake = stake;
        this.taxConfiguration = taxConfiguration || new TaxConfiguration();
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const CouponAction = {
    AddOdd: 0,
    RemoveOdd: 1,
    UpdateStakeValue: 2,
    UpdateGroupings: 3,
    UpdateGroupingStakeValue: 4,
    UpdateOddBankerStatus: 5,
    ClearAllBankers: 6,
    ValidateCoupon: 7,
};
CouponAction[CouponAction.AddOdd] = 'AddOdd';
CouponAction[CouponAction.RemoveOdd] = 'RemoveOdd';
CouponAction[CouponAction.UpdateStakeValue] = 'UpdateStakeValue';
CouponAction[CouponAction.UpdateGroupings] = 'UpdateGroupings';
CouponAction[CouponAction.UpdateGroupingStakeValue] = 'UpdateGroupingStakeValue';
CouponAction[CouponAction.UpdateOddBankerStatus] = 'UpdateOddBankerStatus';
CouponAction[CouponAction.ClearAllBankers] = 'ClearAllBankers';
CouponAction[CouponAction.ValidateCoupon] = 'ValidateCoupon';
/** @enum {number} */
const CouponType = {
    Unknown: 0,
    Single: 1,
    Multiple: 2,
    System: 3,
};
CouponType[CouponType.Unknown] = 'Unknown';
CouponType[CouponType.Single] = 'Single';
CouponType[CouponType.Multiple] = 'Multiple';
CouponType[CouponType.System] = 'System';
/** @enum {number} */
const ResponseStatus = {
    Success: 0,
    Error: 1,
    AlreadyExistsError: 2,
    // not used anymore
    OutrightError: 3,
    CouponContainsUniqueOddError: 4,
    CannotInsertUniqueOddError: 5,
    MaxNoOfSelectionsError: 6,
    MaxNoOfEventsError: 7,
    CannotInsertFixedOddOnCrossCombinationError: 8,
    CannotInsertCrossCombinationOnLiveError: 9,
    // not used anymore
    BankerOnLiveCouponError: 10,
    IncompatibleEvents: 11,
    MinCombinabilityOddsError: 12,
    OddNotExists: 13,
    CannotRemoveOddError: 14,
    CannotRemoveGroupingError: 15,
    GameplayWrong: 16,
    OddChanged: 17,
    EventExpired: 18,
    UnderMinBetStake: 19,
    OverMaxBetStake: 20,
    CouponLimitReached: 21,
    UnderMinBetGroupStake: 22,
    OverMaxBetGroupStake: 23,
    BookingCodeNotAvailable: 405,
};
ResponseStatus[ResponseStatus.Success] = 'Success';
ResponseStatus[ResponseStatus.Error] = 'Error';
ResponseStatus[ResponseStatus.AlreadyExistsError] = 'AlreadyExistsError';
ResponseStatus[ResponseStatus.OutrightError] = 'OutrightError';
ResponseStatus[ResponseStatus.CouponContainsUniqueOddError] = 'CouponContainsUniqueOddError';
ResponseStatus[ResponseStatus.CannotInsertUniqueOddError] = 'CannotInsertUniqueOddError';
ResponseStatus[ResponseStatus.MaxNoOfSelectionsError] = 'MaxNoOfSelectionsError';
ResponseStatus[ResponseStatus.MaxNoOfEventsError] = 'MaxNoOfEventsError';
ResponseStatus[ResponseStatus.CannotInsertFixedOddOnCrossCombinationError] = 'CannotInsertFixedOddOnCrossCombinationError';
ResponseStatus[ResponseStatus.CannotInsertCrossCombinationOnLiveError] = 'CannotInsertCrossCombinationOnLiveError';
ResponseStatus[ResponseStatus.BankerOnLiveCouponError] = 'BankerOnLiveCouponError';
ResponseStatus[ResponseStatus.IncompatibleEvents] = 'IncompatibleEvents';
ResponseStatus[ResponseStatus.MinCombinabilityOddsError] = 'MinCombinabilityOddsError';
ResponseStatus[ResponseStatus.OddNotExists] = 'OddNotExists';
ResponseStatus[ResponseStatus.CannotRemoveOddError] = 'CannotRemoveOddError';
ResponseStatus[ResponseStatus.CannotRemoveGroupingError] = 'CannotRemoveGroupingError';
ResponseStatus[ResponseStatus.GameplayWrong] = 'GameplayWrong';
ResponseStatus[ResponseStatus.OddChanged] = 'OddChanged';
ResponseStatus[ResponseStatus.EventExpired] = 'EventExpired';
ResponseStatus[ResponseStatus.UnderMinBetStake] = 'UnderMinBetStake';
ResponseStatus[ResponseStatus.OverMaxBetStake] = 'OverMaxBetStake';
ResponseStatus[ResponseStatus.CouponLimitReached] = 'CouponLimitReached';
ResponseStatus[ResponseStatus.UnderMinBetGroupStake] = 'UnderMinBetGroupStake';
ResponseStatus[ResponseStatus.OverMaxBetGroupStake] = 'OverMaxBetGroupStake';
ResponseStatus[ResponseStatus.BookingCodeNotAvailable] = 'BookingCodeNotAvailable';
/** @enum {number} */
const CompatibilityLevel = {
    IncompatibleMarket: 0,
    CompatibleMarket: 1,
};
CompatibilityLevel[CompatibilityLevel.IncompatibleMarket] = 'IncompatibleMarket';
CompatibilityLevel[CompatibilityLevel.CompatibleMarket] = 'CompatibleMarket';
/** @enum {number} */
const MarketTag = {
    None: 0,
    OddsBoost: 1,
};
MarketTag[MarketTag.None] = 'None';
MarketTag[MarketTag.OddsBoost] = 'OddsBoost';
/** @enum {number} */
const EvaluationMotivation = {
    Ok: 0,
    UnderMinBetStake: 1,
    OverMaxBetStake: 2,
    CouponLimitReached: 3,
    UnderMinBetGroupStake: 8,
    OverMaxBetGroupStake: 9,
};
EvaluationMotivation[EvaluationMotivation.Ok] = 'Ok';
EvaluationMotivation[EvaluationMotivation.UnderMinBetStake] = 'UnderMinBetStake';
EvaluationMotivation[EvaluationMotivation.OverMaxBetStake] = 'OverMaxBetStake';
EvaluationMotivation[EvaluationMotivation.CouponLimitReached] = 'CouponLimitReached';
EvaluationMotivation[EvaluationMotivation.UnderMinBetGroupStake] = 'UnderMinBetGroupStake';
EvaluationMotivation[EvaluationMotivation.OverMaxBetGroupStake] = 'OverMaxBetGroupStake';
/** @enum {number} */
const AddOddResult = {
    Success: 0,
    SuccessFollowMutiple: 1,
    CouponContainsUniqueOddError: 4,
    CannotInsertUniqueOddError: 5,
    MaxNoOfSelectionsError: 6,
    MaxNoOfEventsError: 7,
    CannotInsertFixedOddOnCrossCombinationError: 8,
    IncompatibleEvents: 11,
    MinCombinabilityOddsError: 12,
};
AddOddResult[AddOddResult.Success] = 'Success';
AddOddResult[AddOddResult.SuccessFollowMutiple] = 'SuccessFollowMutiple';
AddOddResult[AddOddResult.CouponContainsUniqueOddError] = 'CouponContainsUniqueOddError';
AddOddResult[AddOddResult.CannotInsertUniqueOddError] = 'CannotInsertUniqueOddError';
AddOddResult[AddOddResult.MaxNoOfSelectionsError] = 'MaxNoOfSelectionsError';
AddOddResult[AddOddResult.MaxNoOfEventsError] = 'MaxNoOfEventsError';
AddOddResult[AddOddResult.CannotInsertFixedOddOnCrossCombinationError] = 'CannotInsertFixedOddOnCrossCombinationError';
AddOddResult[AddOddResult.IncompatibleEvents] = 'IncompatibleEvents';
AddOddResult[AddOddResult.MinCombinabilityOddsError] = 'MinCombinabilityOddsError';
/** @enum {number} */
const RemoveOddResult = {
    Success: 0,
    SuccessFollowMutiple: 1,
    OddNotExists: 2,
    CannotRemoveOddError: 3,
    CannotRemoveGroupingError: 4,
    Error: 5,
};
RemoveOddResult[RemoveOddResult.Success] = 'Success';
RemoveOddResult[RemoveOddResult.SuccessFollowMutiple] = 'SuccessFollowMutiple';
RemoveOddResult[RemoveOddResult.OddNotExists] = 'OddNotExists';
RemoveOddResult[RemoveOddResult.CannotRemoveOddError] = 'CannotRemoveOddError';
RemoveOddResult[RemoveOddResult.CannotRemoveGroupingError] = 'CannotRemoveGroupingError';
RemoveOddResult[RemoveOddResult.Error] = 'Error';
class UpdateCouponRequest {
    /**
     * @param {?} init
     */
    constructor(init) {
        this.allowSameMatchSelections = true;
        Object.assign(this, init);
    }
}
class UpdateCouponResponse {
    /**
     * @param {?} init
     */
    constructor(init) {
        this.success = false;
        this.updatedCoupon = null;
        this.statusCode = ResponseStatus.Error;
        this.message = null;
        Object.assign(this, init);
    }
}
class BetCouponResponse {
    /**
     * @param {?} responseStatus
     * @param {?=} betCoupon
     */
    constructor(responseStatus, betCoupon) {
        this.ResponseStatus = responseStatus;
        if (betCoupon) {
            this.BetCoupon = betCoupon;
        }
    }
    /**
     * @return {?}
     */
    get ResponseMessage() {
        switch (this.ResponseStatus) {
            case ResponseStatus.Success:
                return 'Success';
            case ResponseStatus.Error:
                return 'Operation Not Allowed';
            case ResponseStatus.AlreadyExistsError:
                return 'Selection has already been added';
            case ResponseStatus.OutrightError:
                return 'Outright error';
            case ResponseStatus.CouponContainsUniqueOddError:
                return 'Cannot add a selection with a unique event';
            case ResponseStatus.CannotInsertUniqueOddError:
                return 'Cannot add a unique event';
            case ResponseStatus.MaxNoOfSelectionsError:
                return 'Max number of selections reached';
            case ResponseStatus.MaxNoOfEventsError:
                return 'Cannot add more than 30 events';
            case ResponseStatus.CannotInsertFixedOddOnCrossCombinationError:
                return 'Banker not allow in cross combination';
            case ResponseStatus.CannotInsertCrossCombinationOnLiveError:
                return 'Cannot insert cross combination on live';
            case ResponseStatus.BankerOnLiveCouponError:
                return 'Banker not allowed on live';
            case ResponseStatus.IncompatibleEvents:
                return 'Related events are incompatible';
            case ResponseStatus.MinCombinabilityOddsError:
                return 'Minimum combinability not reached';
            case ResponseStatus.OddNotExists:
                return 'Odd does not exist';
            case ResponseStatus.CannotRemoveOddError:
                return 'Could not remove odd';
            case ResponseStatus.CannotRemoveGroupingError:
                return 'Could not remove grouping';
            case ResponseStatus.GameplayWrong:
                return 'Wrong game play. Requires more events.';
            case ResponseStatus.OddChanged:
                return 'One of the odds has changed';
            case ResponseStatus.EventExpired:
                return 'One of the chosen events has expired';
            case ResponseStatus.UnderMinBetStake:
                return 'Stake under minimum amount allowed';
            case ResponseStatus.OverMaxBetStake:
                return 'Stake over maximum amount allowed';
            case ResponseStatus.CouponLimitReached:
                return 'Over maximum winning amount';
            case ResponseStatus.UnderMinBetGroupStake:
                return 'Group stake under minimum amount allowed';
            case ResponseStatus.OverMaxBetGroupStake:
                return 'Group stake over maximum amount allowed';
            case ResponseStatus.BookingCodeNotAvailable:
                return 'Booking code is no longer available. All events are expired.';
            default:
                return '';
        }
    }
}
class Bonus {
}
class Selection {
    constructor() {
        this.marketTag = MarketTag.None;
        this.specialValue = '';
    }
}
class BetCouponOdd {
    /**
     * @param {?=} s
     */
    constructor(s) {
        this.Fixed = false;
        if (s) {
            this.IDSport = s.sportId;
            this.SportName = s.sportName;
            this.EventId = s.categoryId;
            this.EventName = s.categoryName;
            this.TournamentId = s.tournamentId;
            this.TournamentName = s.tournamentName;
            this.MatchId = s.matchId;
            this.ParentEventId = s.matchId;
            this.OrderId = s.orderId;
            this.ProviderEventId = s.matchProviderId;
            this.MatchName = s.matchName;
            this.EventDate = s.matchDate;
            this.SelectionId = s.oddId;
            this.IDSelectionType = s.selectionTypeId;
            this.SelectionShortcut = s.selectionShortcut;
            this.SpecialValue = s.specialValue;
            this.MarketId = s.marketId;
            this.MarketTypeId = s.marketTypeId;
            this.MarketTag = s.marketTag || MarketTag.None;
            /** @type {?} */
            const spreadRegex = /\((-?\d+(?:\.\d+)?|(-?\d+\:-?\d+)?|(-?\d+\:-?\d+\.-?\d+)?|(-?\d+\.-?\d+\:-?\d+)?)\)/;
            /** @type {?} */
            const matchMarketName = spreadRegex.exec(s.marketName);
            /** @type {?} */
            const matchSelectionName = spreadRegex.exec(s.selectionName);
            /** @type {?} */
            let spreadInMarket = false;
            if (matchMarketName != null) {
                spreadInMarket = true;
                this.MarketName = s.marketName.replace(matchMarketName[0], '').trim();
            }
            else {
                this.MarketName = s.marketName;
            }
            if (s.spreadValue && (spreadInMarket && s.spreadValue === 0 || s.spreadValue !== 0) && matchSelectionName == null) {
                this.SelectionName = s.selectionName + ' (' + s.spreadValue + ')';
            }
            else {
                this.SelectionName = s.selectionName;
            }
            this.OddValue = s.oddValue;
            this.SmartCode = s.smartBetCode;
            this.EventCategory = s.eventCategory;
            this.IDGroup = s.groupNo;
            this.GamePlay = s.combinability;
            this.IncompatibleEvents = s.incompatibleEvents;
            this.CompatibleMarkets = s.compatibleMarkets;
        }
    }
}
class BetCouponGroup {
    constructor() {
        this.MinWin = 0;
        this.MinWinNet = 0;
        this.NetStakeMinWin = 0;
        this.MaxWin = 0;
        this.MaxWinNet = 0;
        this.NetStakeMaxWin = 0;
        this.MinBonus = 0;
        this.MaxBonus = 0;
        this.MinPercentageBonus = 0;
        this.MaxPercentageBonus = 0;
        this.Stake = -1;
        this.NetStake = -1;
        this.Selected = false;
    }
}
class BetCouponGroupMissing {
}
class BetCouponGlobalVariable {
    constructor() {
        this.IsVirtualsInstallation = false;
    }
}
class BetCoupon {
    /**
     * @param {?=} globalVariables
     */
    constructor(globalVariables = new BetCouponGlobalVariable()) {
        this.HasLive = false;
        this.CouponType = CouponType.Unknown;
        this.IsClientSideCoupon = true;
        this.CurrencyId = globalVariables.CurrencyId || 1;
        this.TaxPercentage = 0;
        this.Stake = globalVariables.MinBetStakeSingle || globalVariables.DefaultStakeGross || 1;
        this.StakeGross = globalVariables.MinBetStakeSingle || globalVariables.DefaultStakeGross || 1;
        this.Odds = new Array();
        this.Groupings = new Array();
        this.PossibleMissingGroupings = new Array();
        this.AllGroupings = new Array();
    }
    /**
     * @return {?}
     */
    MaxGrouping() {
        /** @type {?} */
        const ret = Number.MAX_VALUE;
        // lottery skip for now
        /** @type {?} */
        const compatibleMarketsCount = this.Odds.filter((/**
         * @param {?} o
         * @return {?}
         */
        o => o.CompatibilityLevel === CompatibilityLevel.CompatibleMarket)).length;
        /** @type {?} */
        const incompatibleOdds = this.Odds.filter((/**
         * @param {?} o
         * @return {?}
         */
        o => o.CompatibilityLevel === CompatibilityLevel.IncompatibleMarket));
        /** @type {?} */
        const incompatibleMarketsEventCount = uniqBy(incompatibleOdds, 'MatchId').length;
        /** @type {?} */
        const temp_ret = compatibleMarketsCount + incompatibleMarketsEventCount;
        if (temp_ret > ret) {
            return ret;
        }
        else {
            return temp_ret;
        }
    }
    /**
     * @return {?}
     */
    MinBetStake() {
        /** @type {?} */
        const globalVariables = this.BetCouponGlobalVariable;
        switch (this.CouponTypeId) {
            case CouponType.Single:
                return globalVariables.MinBetStakeSingle != null ? globalVariables.MinBetStakeSingle : globalVariables.MinBetStake;
            case CouponType.Multiple:
                return globalVariables.MinBetStakeMultiple != null ? globalVariables.MinBetStakeMultiple : globalVariables.MinBetStake;
            case CouponType.System:
                return globalVariables.MinBetStakeCombination != null ? globalVariables.MinBetStakeCombination : globalVariables.MinBetStake;
            case CouponType.Unknown:
            default:
                return globalVariables.MinBetStake;
        }
    }
    /**
     * @return {?}
     */
    setAllowFixed() {
        for (let i = 0; i < this.Odds.length; i++) {
            /** @type {?} */
            const odd = this.Odds[i];
            /** @type {?} */
            const x = this.Odds.filter((/**
             * @param {?} o
             * @return {?}
             */
            o => o.MatchId === odd.MatchId && o.SelectionId !== odd.SelectionId));
            if (x.length > 0) {
                odd.AllowFixed = false;
            }
            else {
                odd.AllowFixed = true;
            }
        }
    }
    /**
     * @return {?}
     */
    setTotalOdds() {
        // if (this.CouponTypeId == CouponType.CombinationsBet) {
        //    this.TotalOdds = 0;
        // } else {
        //    this.TotalOdds = this.Odds.reduce((product, next) => product * next.OddValue, 1);
        // }
        this.TotalOdds = this.Odds.reduce((/**
         * @param {?} product
         * @param {?} next
         * @return {?}
         */
        (product, next) => product * next.OddValue), 1);
    }
    /**
     * @return {?}
     */
    getTax() {
        return this.TaxPercentage / 100;
    }
    /**
     * @return {?}
     */
    setTax() {
        this.Tax = this.getTax();
    }
    /**
     * @return {?}
     */
    getStakeTaxed() {
        return this.StakeGross * this.getTax();
    }
    /**
     * @return {?}
     */
    setStakeTaxed() {
        this.StakeTaxed = this.getStakeTaxed();
    }
    /**
     * @return {?}
     */
    getStake() {
        return this.StakeGross - this.getStakeTaxed();
    }
    /**
     * @return {?}
     */
    setStake() {
        this.Stake = this.getStake();
    }
    /**
     * @param {?} coupon
     * @param {?} brandID
     * @return {?}
     */
    calculateAndSetTaxes(coupon, brandID) {
        /** @type {?} */
        const taxModule = TaxationService.Instance.getModuleByBrandID(brandID);
        if (!taxModule) {
            return;
        }
        /** @type {?} */
        const currDate = new Date();
        /** @type {?} */
        const taxConfiguration = new TaxConfiguration({ isVirtual: coupon.BetCouponGlobalVariable.IsVirtualsInstallation });
        /** @type {?} */
        const turnoverTax = taxModule.calculateTurnoverTax(new TurnoverTaxParameter(currDate, this.Stake, taxConfiguration));
        /** @type {?} */
        const minWinValues = this.Groupings.map((/**
         * @param {?} g
         * @return {?}
         */
        g => {
            /** @type {?} */
            const wwt = taxModule.calculateWithholdingTax(new WithholdingTaxParameter(currDate, g.MinWinNet + g.MinBonus, g.NetStake, taxConfiguration));
            // Apply withholding tax on the inner grouping
            g.MinWinNet = wwt.totalAfterTax;
            return {
                winAfterTax: wwt.totalAfterTax,
                winTaxed: wwt.totalTaxed,
                bonus: g.MinBonus
            };
        }));
        /** @type {?} */
        const maxWinValues = this.Groupings.map((/**
         * @param {?} g
         * @return {?}
         */
        g => {
            /** @type {?} */
            const wwt = taxModule.calculateWithholdingTax(new WithholdingTaxParameter(currDate, g.MaxWinNet + g.MaxBonus, g.NetStake * g.Combinations, taxConfiguration));
            // Apply withholding tax on the inner grouping
            g.MaxWinNet = wwt.totalAfterTax;
            return {
                winAfterTax: wwt.totalAfterTax,
                winTaxed: wwt.totalTaxed,
                bonus: g.MaxBonus
            };
        }));
        if (turnoverTax) {
            this.TurnoverTax = turnoverTax.totalTaxed;
        }
        if (minWinValues.length > 0) {
            /** @type {?} */
            const winAfterTax = minBy(minWinValues, 'winAfterTax').winAfterTax;
            /** @type {?} */
            const minBonus = minBy(minWinValues, 'bonus').bonus;
            // Bonus is being added to the win to replicate the hotfix released on the Sportsbook API
            this.MinWinNet = winAfterTax;
            this.MinBonus = minBonus;
            this.MinWithholdingTax = minBy(minWinValues, 'winTaxed').winTaxed;
        }
        if (maxWinValues.length > 0) {
            /** @type {?} */
            const winAfterTax = sumBy(maxWinValues, 'winAfterTax');
            /** @type {?} */
            const maxBonus = sumBy(maxWinValues, 'bonus');
            // Bonus is being added to the win to replicate the hotfix released on the Sportsbook API
            this.MaxWinNet = winAfterTax;
            this.MaxBonus = maxBonus;
            this.MaxWithholdingTax = sumBy(maxWinValues, 'winTaxed');
        }
    }
}
class ResponseStatusHelper {
    /**
     * @param {?} status
     * @return {?}
     */
    convertAddOddResult(status) {
        switch (status) {
            case AddOddResult.Success:
                return ResponseStatus.Success;
            case AddOddResult.SuccessFollowMutiple:
                return ResponseStatus.Success;
            case AddOddResult.CouponContainsUniqueOddError:
                return ResponseStatus.CouponContainsUniqueOddError;
            case AddOddResult.CannotInsertUniqueOddError:
                return ResponseStatus.CannotInsertUniqueOddError;
            case AddOddResult.MaxNoOfSelectionsError:
                return ResponseStatus.MaxNoOfSelectionsError;
            case AddOddResult.MaxNoOfEventsError:
                return ResponseStatus.MaxNoOfEventsError;
            case AddOddResult.CannotInsertFixedOddOnCrossCombinationError:
                return ResponseStatus.CannotInsertFixedOddOnCrossCombinationError;
            case AddOddResult.IncompatibleEvents:
                return ResponseStatus.IncompatibleEvents;
            default:
                return ResponseStatus.Error;
        }
    }
    /**
     * @param {?} status
     * @return {?}
     */
    convertRemoveOddResult(status) {
        switch (status) {
            case RemoveOddResult.Success:
                return ResponseStatus.Success;
            case RemoveOddResult.SuccessFollowMutiple:
                return ResponseStatus.Success;
            case RemoveOddResult.OddNotExists:
                return ResponseStatus.OddNotExists;
            case RemoveOddResult.CannotRemoveOddError:
                return ResponseStatus.CannotRemoveOddError;
            case RemoveOddResult.CannotRemoveGroupingError:
                return ResponseStatus.CannotRemoveGroupingError;
            default:
                return ResponseStatus.Error;
        }
    }
    /**
     * @param {?} status
     * @return {?}
     */
    convertEvaluationMotivation(status) {
        switch (status) {
            case EvaluationMotivation.Ok:
                return ResponseStatus.Success;
            case EvaluationMotivation.UnderMinBetStake:
                return ResponseStatus.UnderMinBetStake;
            case EvaluationMotivation.OverMaxBetStake:
                return ResponseStatus.OverMaxBetStake;
            case EvaluationMotivation.CouponLimitReached:
                return ResponseStatus.CouponLimitReached;
            case EvaluationMotivation.UnderMinBetGroupStake:
                return ResponseStatus.UnderMinBetGroupStake;
            case EvaluationMotivation.OverMaxBetGroupStake:
                return ResponseStatus.OverMaxBetGroupStake;
            default:
                return ResponseStatus.Error;
        }
    }
}
class PartitionOdd {
    constructor() {
        this.MaxOdd = 0;
        this.MinOdd = 0;
        this.CompatibleOdds = [];
        this.IncompatibleOdds = [];
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CalculatedGroup {
    /**
     * @return {?}
     */
    MinWin() {
        return this.MinWinForUnit * this.StakeForCombination;
    }
    /**
     * @return {?}
     */
    NetStakeMinWin() {
        return this.MinWinForUnit * this.StakeForCombinationTaxed;
    }
    /**
     * @return {?}
     */
    MaxWin() {
        return this.MaxWinForUnit * this.StakeForCombination;
    }
    /**
     * @return {?}
     */
    NetStakeMaxWin() {
        return this.MaxWinForUnit * this.StakeForCombinationTaxed;
    }
    /**
     * @return {?}
     */
    MinBonus() {
        return this.MinBonusForUnit * this.StakeForCombinationTaxed;
    }
    /**
     * @return {?}
     */
    MaxBonus() {
        return this.MaxBonusForUnit * this.StakeForCombinationTaxed;
    }
    /**
     * @param {?} grouping
     * @param {?=} combinations
     * @param {?=} stakeForCombination
     * @param {?=} minPercentageBonus
     * @param {?=} maxPercentageBonus
     * @param {?=} minWinForUnit
     * @param {?=} maxWinForUnit
     * @param {?=} minBonusForUnit
     * @param {?=} maxBonusForUnit
     */
    constructor(grouping, combinations, stakeForCombination, minPercentageBonus, maxPercentageBonus, minWinForUnit, maxWinForUnit, minBonusForUnit, maxBonusForUnit) {
        this.Grouping = grouping;
        this.Combinations = combinations || 0;
        this.StakeForCombination = stakeForCombination || 0;
        this.MinPercentageBonus = minPercentageBonus || 0;
        this.MaxPercentageBonus = maxPercentageBonus || 0;
        this.MinWinForUnit = minWinForUnit || 0;
        this.MaxWinForUnit = maxWinForUnit || 0;
        this.MinBonusForUnit = minBonusForUnit || 0;
        this.MaxBonusForUnit = maxBonusForUnit || 0;
    }
}
class CalculatedCoupon {
    constructor() {
        this.Groups = new Array();
    }
    /**
     * @param {?} lossThreshold
     * @param {?} stakeThreshold
     * @param {?} maxGrouping
     * @param {?} selectedGroupings
     * @param {?} totalCouponCombinations
     * @return {?}
     */
    getMaxAllowedStake(lossThreshold, stakeThreshold, maxGrouping, selectedGroupings, totalCouponCombinations) {
        /** @type {?} */
        let totalCurrentLossForUnit = this.getTotalWinForUnit(selectedGroupings) + this.getTotalBonusForUnit(selectedGroupings);
        if (totalCurrentLossForUnit === 0) {
            totalCurrentLossForUnit = 1;
        }
        /** @type {?} */
        let newTotalStake = (lossThreshold / totalCurrentLossForUnit) * totalCouponCombinations;
        if (stakeThreshold > 0) {
            newTotalStake = newTotalStake > stakeThreshold ? stakeThreshold : newTotalStake;
        }
        newTotalStake = newTotalStake * 100;
        newTotalStake = Math.floor(newTotalStake);
        newTotalStake = newTotalStake / 100;
        // consider rounding later on
        // Math.Round(newTotalStake, 2);
        return newTotalStake;
    }
    /**
     * @param {?} selectedGroupings
     * @return {?}
     */
    getTotalWinForUnit(selectedGroupings) {
        if (selectedGroupings.length > 0) {
            return sumBy(this.Groups.filter((/**
             * @param {?} g
             * @return {?}
             */
            g => selectedGroupings.indexOf(g.Grouping) !== -1)), 'MaxWinForUnit');
        }
        else {
            return 0;
        }
    }
    /**
     * @param {?} selectedGroupings
     * @return {?}
     */
    getTotalBonusForUnit(selectedGroupings) {
        if (selectedGroupings.length > 0) {
            return sumBy(this.Groups.filter((/**
             * @param {?} g
             * @return {?}
             */
            g => selectedGroupings.indexOf(g.Grouping) !== -1)), 'MaxBonusForUnit');
        }
        else {
            return 0;
        }
    }
}
class SlotKey {
    /**
     * @param {?} _matchId
     * @param {?} _index
     */
    constructor(_matchId, _index) {
        this.MatchId = _matchId;
        this.Index = _index;
    }
    /**
     * @return {?}
     */
    getKey() {
        return this.MatchId + '_' + this.Index;
    }
}
class Combination {
    /**
     * @param {?=} n
     * @param {?=} k
     */
    constructor(n, k) {
        if (n && k) {
            if (n < 0 || k < 0) {
                throw new Error('Negative parameter in constructor');
            }
            this.n = n;
            this.k = k;
            this.data = new Array();
            for (let i = 0; i < k; i++) {
                this.data[i] = i;
            }
        }
    }
    /**
     * @return {?}
     */
    successor() {
        if (this.data.length === 0 || this.data[0] === this.n - this.k) {
            return null;
        }
        /** @type {?} */
        const result = new Combination(this.n, this.k);
        /** @type {?} */
        let i = 0;
        for (i = 0; i < this.k; i++) {
            result.data[i] = this.data[i];
        }
        for (i = this.k - 1; i > 0 && result.data[i] === this.n - this.k + i;) {
            i--;
        }
        result.data[i]++;
        for (let j = i; j < this.k - 1; j++) {
            result.data[j + 1] = result.data[j] + 1;
        }
        return result;
    }
    /**
     * @return {?}
     */
    first() {
        /** @type {?} */
        const result = new Combination(this.n, this.k);
        for (let i = 0; i < result.k; ++i) {
            result.data[i] = i;
        }
        return result;
    }
    /**
     * @template T
     * @param {?} array
     * @return {?}
     */
    applyTo(array) {
        if (array.length !== this.n) {
            throw new Error('Array size not equal to Combination order in ApplyTo()');
        }
        /** @type {?} */
        const result = new Array();
        for (let i = 0; i < this.k; i++) {
            result[i] = array[this.data[i]];
        }
        return result;
    }
    /**
     * @param {?} n
     * @param {?} k
     * @return {?}
     */
    choose(n, k) {
        if (n < 0 || k < 0) {
            throw new Error('Invalid negative parameter in Choose()');
        }
        if (n < k) {
            return 0;
        }
        if (n === k || k === 0) {
            return 1;
        }
        /** @type {?} */
        let delta = 0;
        /** @type {?} */
        let iMax = 0;
        if (k < n - k) {
            delta = n - k;
            iMax = k;
        }
        else {
            delta = k;
            iMax = n - k;
        }
        /** @type {?} */
        let result = delta + 1;
        for (let i = 2; i <= iMax; ++i) {
            result = (result * (delta + i)) / i;
        }
        return result;
    }
}
class FastCombination {
    /**
     * @param {?} rows
     * @return {?}
     */
    create2Darray(rows) {
        /** @type {?} */
        const arr = [];
        for (let i = 0; i < rows; i++) {
            arr[i] = [];
        }
        return arr;
    }
    /**
     * @param {?} setSizes
     * @param {?} k
     * @return {?}
     */
    chooseFromSets(setSizes, k) {
        /** @type {?} */
        const n = setSizes.length;
        if (k === 0 || k > n) {
            return 0;
        }
        /** @type {?} */
        let result = 0;
        /** @type {?} */
        const m = this.create2Darray(k + 1);
        for (let y = 1; y <= n - k + 1; y++) {
            if (y === 1) {
                for (let x = 1; x <= k; x++) {
                    m[x][y] = take(setSizes, x).reduce((/**
                     * @param {?} product
                     * @param {?} next
                     * @return {?}
                     */
                    (product, next) => product * next), 1);
                    result = m[x][y];
                }
            }
            else {
                m[1][y] = take(setSizes, y).reduce((/**
                 * @param {?} a
                 * @param {?} b
                 * @return {?}
                 */
                (a, b) => a + b), 0);
                result = m[1][y];
                for (let x = 2; x <= k; x++) {
                    m[x][y] = m[x][y - 1] + m[x - 1][y] * setSizes[x + y - 2];
                    result = m[x][y];
                }
            }
        }
        return result;
    }
}
class CouponCalculation {
    /**
     * @param {?} correctScoreOddsMatrix
     */
    constructor(correctScoreOddsMatrix) {
        this.fastCombination = new FastCombination();
        this.selectionCompatibilityMatrixEngine = new SelectionCompatibilityMatrixEngine(correctScoreOddsMatrix);
    }
    /**
     * @param {?} key
     * @return {?}
     */
    getSlotKeyFromString(key) {
        /** @type {?} */
        const splitKey = key.split('_');
        /** @type {?} */
        const matchId = Number(splitKey[0]);
        /** @type {?} */
        const index = Number(splitKey[1]);
        return new SlotKey(matchId, index);
    }
    /**
     * @param {?} coupon
     * @return {?}
     */
    getOddsForSlotKeyMap(coupon) {
        /** @type {?} */
        const oddsForSlotKeyMap = {};
        for (let i = 0; i < coupon.Odds.length; i++) {
            /** @type {?} */
            const odd = coupon.Odds[i];
            switch (odd.CompatibilityLevel) {
                case CompatibilityLevel.IncompatibleMarket: {
                    /** @type {?} */
                    const keys = new Array();
                    for (const key of Object.keys(oddsForSlotKeyMap)) {
                        /** @type {?} */
                        const slotKey = this.getSlotKeyFromString(key);
                        if (slotKey.MatchId === odd.MatchId && slotKey.Index === 0) {
                            keys.push(slotKey);
                        }
                        else if (slotKey.MatchId === odd.MatchId && slotKey.Index > 0) {
                            throw new Error('Mixed CompatibilityLevel on odds');
                        }
                    }
                    if (keys.length > 1) {
                        throw new Error('Wrong oddsForSlotKeyMap construction');
                    }
                    if (keys.length === 0) {
                        /** @type {?} */
                        const sk = new SlotKey(odd.MatchId, 0);
                        /** @type {?} */
                        const x = new Array();
                        x.push(odd);
                        oddsForSlotKeyMap[sk.getKey()] = x;
                    }
                    else {
                        /** @type {?} */
                        const sk = keys[0];
                        /** @type {?} */
                        const currentSK = (/** @type {?} */ (oddsForSlotKeyMap[sk.getKey()]));
                        currentSK.push(odd);
                        // check bankers
                    }
                    break;
                }
                case CompatibilityLevel.CompatibleMarket: {
                    /** @type {?} */
                    const keys = new Array();
                    for (const key of Object.keys(oddsForSlotKeyMap)) {
                        /** @type {?} */
                        const slotKey = this.getSlotKeyFromString(key);
                        if (slotKey.MatchId === odd.MarketId) {
                            keys.push(slotKey);
                        }
                    }
                    if (keys.length > 0) {
                        /** @type {?} */
                        const maxIndex = maxBy(keys, 'Index').Index;
                        /** @type {?} */
                        const sk = new SlotKey(odd.MatchId, maxIndex + 1);
                        /** @type {?} */
                        const x = new Array();
                        x.push(odd);
                        oddsForSlotKeyMap[sk.getKey()] = x;
                    }
                    else {
                        /** @type {?} */
                        const sk = new SlotKey(odd.MatchId, 1);
                        /** @type {?} */
                        const x = new Array();
                        x.push(odd);
                        oddsForSlotKeyMap[sk.getKey()] = x;
                    }
                    break;
                }
            }
        }
        return oddsForSlotKeyMap;
    }
    /**
     * @param {?} coupon
     * @return {?}
     */
    calcCombinations(coupon) {
        /** @type {?} */
        const maxCombinationForCoupon = Math.min(coupon.BetCouponGlobalVariable.MaxCombinationsByGrouping, coupon.BetCouponGlobalVariable.MaxCouponCombinations);
        if (coupon.Odds.length > 0 && coupon.Odds.filter((/**
         * @param {?} o
         * @return {?}
         */
        o => o.Fixed)).length === coupon.Odds.length) {
            coupon.Odds[0].Fixed = false;
        }
        /** @type {?} */
        const calculatedCouponGroups = new Array();
        /** @type {?} */
        const oddsForSlotKeyMap = this.getOddsForSlotKeyMap(coupon);
        /** @type {?} */
        const bankers = new Array();
        /** @type {?} */
        const nonBankers = new Array();
        /** @type {?} */
        let slotKeyCount = 0;
        /** @type {?} */
        let integrale = false;
        /** @type {?} */
        const numSelectionsPerEvent = new Array();
        for (const key of Object.keys(oddsForSlotKeyMap)) {
            /** @type {?} */
            const currentSK = (/** @type {?} */ (oddsForSlotKeyMap[key]));
            if (currentSK[0].Fixed) {
                bankers.push(currentSK[0]);
            }
            else {
                nonBankers.push(currentSK);
                numSelectionsPerEvent.push(currentSK.length);
            }
            slotKeyCount += 1;
            if (currentSK.length > 1) {
                integrale = true;
            }
        }
        /** @type {?} */
        const firstGroup = bankers.length > 0 ? bankers.length : 1;
        for (let groupIndex = 0; groupIndex <= slotKeyCount; groupIndex++) {
            /** @type {?} */
            let group = null;
            if (groupIndex > 0) {
                group = new CalculatedGroup(groupIndex);
                if (groupIndex < firstGroup) {
                    group.Combinations = 0;
                }
            }
            calculatedCouponGroups.push(group);
        }
        if (bankers.length > 0) {
            calculatedCouponGroups[bankers.length].Combinations = 0;
        }
        if (!integrale) {
            for (let k = nonBankers.length; k > 0; k--) {
                /** @type {?} */
                const n = nonBankers.length;
                /** @type {?} */
                const nc = new Combination().choose(n, k);
                if (maxCombinationForCoupon > nc) {
                    calculatedCouponGroups[k + bankers.length].Combinations = nc;
                }
                else {
                    calculatedCouponGroups[k + bankers.length].Combinations = -1;
                }
            }
        }
        else {
            for (let k = nonBankers.length; k > 0; k--) {
                /** @type {?} */
                const combinationsCount = this.calcCombinationsForCrossCombinationsBetGroup(k, numSelectionsPerEvent, maxCombinationForCoupon);
                calculatedCouponGroups[k + bankers.length].Combinations = combinationsCount;
            }
        }
        /** @type {?} */
        const maxPossibleGroupings = coupon.MaxGrouping();
        for (let index = 0; index < calculatedCouponGroups.length; index++) {
            if (calculatedCouponGroups[index] == null || calculatedCouponGroups[index].Grouping > maxPossibleGroupings) {
                calculatedCouponGroups.splice(index, 1);
                index--;
            }
        }
        /** @type {?} */
        const calculatedCoupon = new CalculatedCoupon();
        calculatedCouponGroups.forEach((/**
         * @param {?} g
         * @return {?}
         */
        g => calculatedCoupon.Groups.push(g)));
        return calculatedCoupon;
    }
    /**
     * @param {?} k
     * @param {?} numSelectionsPerEvent
     * @param {?} maxCombinationForCoupon
     * @return {?}
     */
    calcCombinationsForCrossCombinationsBetGroup(k, numSelectionsPerEvent, maxCombinationForCoupon) {
        /** @type {?} */
        const choosen = this.fastCombination.chooseFromSets(numSelectionsPerEvent, k);
        if (choosen > maxCombinationForCoupon) {
            return -1;
        }
        return choosen;
    }
    /**
     * @param {?} coupon
     * @param {?} bonusList
     * @param {?} brandID
     * @return {?}
     */
    calcPotentialWins(coupon, bonusList, brandID) {
        /** @type {?} */
        const taxModule = TaxationService.Instance.getModuleByBrandID(brandID);
        /** @type {?} */
        const maxCombinationForCoupon = Math.min(coupon.BetCouponGlobalVariable.MaxCombinationsByGrouping, coupon.BetCouponGlobalVariable.MaxCouponCombinations);
        /** @type {?} */
        const partitions = this.selectionCompatibilityMatrixEngine.Slot(coupon.Odds);
        /** @type {?} */
        const bankers = new Array();
        /** @type {?} */
        const nonBankers = new Array();
        /** @type {?} */
        const nonBankerPartitions = new Array();
        partitions.values().forEach((/**
         * @param {?} partition
         * @return {?}
         */
        partition => {
            /** @type {?} */
            const pOdds = unionWith(partition.CompatibleOdds, partition.IncompatibleOdds, isEqual);
            if (pOdds[0].Fixed) {
                bankers.push(pOdds[0]);
            }
            else {
                nonBankers.push(pOdds);
                nonBankerPartitions.push(partition);
            }
        }));
        /** @type {?} */
        const maxCombination = [];
        /** @type {?} */
        const minCombination = [];
        for (let i = 0; i < nonBankers.length; i++) {
            /** @type {?} */
            let compatibleOddValue = 0;
            /** @type {?} */
            let incompatibleOddValue = 0;
            nonBankerPartitions[i].CompatibleOdds.forEach((/**
             * @param {?} x
             * @return {?}
             */
            x => (compatibleOddValue += x.OddValue)));
            nonBankerPartitions[i].IncompatibleOdds.forEach((/**
             * @param {?} x
             * @return {?}
             */
            x => (incompatibleOddValue *= x.OddValue)));
            maxCombination[i] = Math.max(compatibleOddValue, incompatibleOddValue);
            minCombination[i] = nonBankerPartitions[i].MinOdd;
        }
        /** @type {?} */
        const calculatedCouponGroups = new Array();
        for (let i = 0; i < coupon.Groupings.length; i++) {
            /** @type {?} */
            const betCouponGroup = coupon.Groupings[i];
            if (betCouponGroup.Combinations > 0) {
                /** @type {?} */
                let stakeTaxed = betCouponGroup.Stake;
                if (taxModule) {
                    /** @type {?} */
                    const taxConfiguration = new TaxConfiguration({
                        isVirtual: coupon.BetCouponGlobalVariable.IsVirtualsInstallation
                    });
                    stakeTaxed = taxModule.calculateTurnoverTax(new TurnoverTaxParameter(new Date(), betCouponGroup.Stake, taxConfiguration))
                        .totalAfterTax;
                }
                /** @type {?} */
                const calculatedGroup = new CalculatedGroup(betCouponGroup.Grouping);
                calculatedGroup.Combinations = betCouponGroup.Combinations;
                calculatedGroup.StakeForCombination = betCouponGroup.Stake;
                calculatedGroup.StakeForCombinationTaxed = stakeTaxed;
                calculatedCouponGroups.push(calculatedGroup);
            }
        }
        if (coupon.Groupings.length === 0 && bankers.length + nonBankers.length === 1) {
            /** @type {?} */
            let combinations = 1;
            if (nonBankers.length > 0) {
                combinations = nonBankers[0].length;
            }
            /** @type {?} */
            const calculatedGroup = new CalculatedGroup(1);
            calculatedGroup.Combinations = combinations;
            calculatedGroup.StakeForCombination = coupon.getStake() / combinations;
            calculatedCouponGroups.push(calculatedGroup);
        }
        /** @type {?} */
        let bankersValidEventForBonus = 0;
        /** @type {?} */
        let bankersTotalOdds = 1.0;
        for (let i = 0; i < bankers.length; i++) {
            /** @type {?} */
            const b = bankers[i];
            bankersTotalOdds *= b.OddValue;
            bankersTotalOdds = Number(bankersTotalOdds.toFixed(10)); // Attempting to work around the javascript precision issue
            if (b.OddValue >= coupon.BetCouponGlobalVariable.MinBonusOdd) {
                bankersValidEventForBonus++;
            }
        }
        for (let i = 0; i < calculatedCouponGroups.length; i++) {
            /** @type {?} */
            const calculatedGroup = calculatedCouponGroups[i];
            /** @type {?} */
            const n = nonBankers.length;
            /** @type {?} */
            const k = calculatedGroup.Grouping - bankers.length;
            /** @type {?} */
            const nc = new Combination().choose(n, k);
            /** @type {?} */
            let maxWinForUnit = 0.0;
            /** @type {?} */
            let maxBonusForUnit = 0.0;
            if (maxCombinationForCoupon > nc) {
                /** @type {?} */
                let combination = new Combination(n, k);
                for (let j = 0; j < nc; j++) {
                    /** @type {?} */
                    let validEventsForBonus = bankersValidEventForBonus;
                    /** @type {?} */
                    let winForUnit = bankersTotalOdds;
                    /** @type {?} */
                    const combOdds = combination.applyTo(maxCombination);
                    for (let l = 0; l < combOdds.length; l++) {
                        /** @type {?} */
                        const odd = combOdds[l];
                        winForUnit *= odd;
                        winForUnit = Number(winForUnit.toFixed(10)); // Attempting to work around the javascript precision issue
                        if (odd >= coupon.BetCouponGlobalVariable.MinBonusOdd) {
                            validEventsForBonus++;
                        }
                    }
                    /** @type {?} */
                    const percBonus = this.bonusPercentageFromNumberOfEvents(bonusList, validEventsForBonus);
                    maxWinForUnit += winForUnit;
                    maxBonusForUnit += winForUnit * percBonus;
                    combination = combination.successor();
                    calculatedGroup.MaxPercentageBonus = percBonus;
                }
            }
            calculatedGroup.MaxWinForUnit = maxWinForUnit;
            calculatedGroup.MaxBonusForUnit = maxBonusForUnit;
            /** @type {?} */
            let minWinForUnit = bankersTotalOdds;
            /** @type {?} */
            let minEventForBonus = bankersValidEventForBonus;
            /** @type {?} */
            const sortedMinComb = orderBy(minCombination, (/**
             * @param {?} v
             * @return {?}
             */
            v => v), 'asc');
            /** @type {?} */
            const subSortedMinComb = take(sortedMinComb, k);
            for (let j = 0; j < subSortedMinComb.length; j++) {
                /** @type {?} */
                const odd = subSortedMinComb[j];
                // PS: This multiplication (and possibly all others) suffer from the problem
                // of javascript floating point precision. This results in a total max win which
                // might vary slightly from the server's calculations.
                minWinForUnit *= odd;
                minWinForUnit = Number(minWinForUnit.toFixed(10)); // Attempting to work around the javascript precision issue
                if (odd >= coupon.BetCouponGlobalVariable.MinBonusOdd) {
                    minEventForBonus++;
                }
            }
            /** @type {?} */
            const minPercBonus = this.bonusPercentageFromNumberOfEvents(bonusList, minEventForBonus);
            calculatedGroup.MinWinForUnit = minWinForUnit;
            calculatedGroup.MinBonusForUnit = minWinForUnit * minPercBonus;
            calculatedGroup.MinPercentageBonus = minPercBonus;
        }
        /** @type {?} */
        const calculatedCoupon = new CalculatedCoupon();
        calculatedCouponGroups.forEach((/**
         * @param {?} g
         * @return {?}
         */
        g => calculatedCoupon.Groups.push(g)));
        return calculatedCoupon;
    }
    /**
     * @private
     * @param {?} bonusList
     * @param {?} numberOfEvents
     * @return {?}
     */
    bonusPercentageFromNumberOfEvents(bonusList, numberOfEvents) {
        if (!bonusList || bonusList.length === 0) {
            return 0.0;
        }
        if (numberOfEvents < minBy(bonusList, 'NumberOfEvents').NumberOfEvents) {
            return 0.0;
        }
        if (numberOfEvents > maxBy(bonusList, 'NumberOfEvents').NumberOfEvents) {
            return 0.0;
        }
        /** @type {?} */
        const filteredBonusList = bonusList.filter((/**
         * @param {?} b
         * @return {?}
         */
        b => b.NumberOfEvents === numberOfEvents));
        if (filteredBonusList.length > 0) {
            /** @type {?} */
            const item = filteredBonusList[0];
            return item.Percentage / 100.0;
        }
        throw new Error("Can't find the bonus percentage for " + numberOfEvents + ' events');
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template K, V
 */
class Dictionary {
    /**
     * @param {?=} init
     */
    constructor(init) {
        this._keys = new Array();
        this._values = new Array();
        if (init) {
            for (const key of Object.keys(init)) {
                this.add((/** @type {?} */ (Number(key))), (/** @type {?} */ (init[key])));
            }
        }
    }
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    add(key, value) {
        this[key.toString()] = value;
        this._keys.push(key);
        this._values.push(value);
    }
    /**
     * @param {?} key
     * @return {?}
     */
    remove(key) {
        /** @type {?} */
        const index = this._keys.indexOf(key, 0);
        this._keys.splice(index, 1);
        this._values.splice(index, 1);
        delete this[key.toString()];
    }
    /**
     * @param {?} key
     * @return {?}
     */
    containsKey(key) {
        if (this[key.toString()] == null) {
            return false;
        }
        return true;
    }
    /**
     * @return {?}
     */
    keys() {
        return this._keys;
    }
    /**
     * @return {?}
     */
    values() {
        return this._values;
    }
}
/**
 * @template T
 */
class StringDictionary {
    /**
     * @param {?=} init
     */
    constructor(init) {
        this._keys = [];
        this._values = [];
        if (init) {
            for (let x = 0; x < init.length; x++) {
                this[init[x].key] = init[x].value;
                this._keys.push(init[x].key);
                this._values.push(init[x].value);
            }
        }
    }
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    add(key, value) {
        this[key] = value;
        this._keys.push(key);
        this._values.push(value);
    }
    /**
     * @param {?} key
     * @return {?}
     */
    remove(key) {
        /** @type {?} */
        const index = this._keys.indexOf(key, 0);
        this._keys.splice(index, 1);
        this._values.splice(index, 1);
        delete this[key];
    }
    /**
     * @return {?}
     */
    keys() {
        return this._keys;
    }
    /**
     * @return {?}
     */
    values() {
        return this._values;
    }
    /**
     * @param {?} key
     * @return {?}
     */
    containsKey(key) {
        if (typeof this[key] === 'undefined') {
            return false;
        }
        return true;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CouponEvaluator {
    /**
     * @param {?} betCoupon
     * @return {?}
     */
    evaluate(betCoupon) {
        /** @type {?} */
        const couponStake = betCoupon.StakeGross;
        /** @type {?} */
        const betCouponGroups = betCoupon.Groupings;
        /** @type {?} */
        const couponGlobalVariable = betCoupon.BetCouponGlobalVariable;
        if (couponStake > couponGlobalVariable.MaxBetStake) {
            return EvaluationMotivation.OverMaxBetStake;
        }
        if (couponStake < betCoupon.MinBetStake()) {
            return EvaluationMotivation.UnderMinBetStake;
        }
        for (let i = 0; i < betCouponGroups.length; i++) {
            /** @type {?} */
            const betCouponGroup = betCouponGroups[i];
            if (betCouponGroup.Stake > couponGlobalVariable.MaxGroupingsBetStake) {
                return EvaluationMotivation.OverMaxBetGroupStake;
            }
            if (betCouponGroup.Stake < couponGlobalVariable.MinGroupingsBetStake) {
                return EvaluationMotivation.UnderMinBetGroupStake;
            }
        }
        /** @type {?} */
        let maxWin = 0;
        switch (betCoupon.CouponTypeId) {
            case CouponType.Single: {
                maxWin = couponGlobalVariable.MaxSingleBetWin;
                break;
            }
            case CouponType.Multiple: {
                maxWin = couponGlobalVariable.MaxMultipleBetWin;
                break;
            }
            case CouponType.System: {
                maxWin = couponGlobalVariable.MaxCombinationBetWin;
                break;
            }
        }
        if (betCoupon.MaxWin + betCoupon.MaxBonus > maxWin) {
            return EvaluationMotivation.CouponLimitReached;
        }
        return EvaluationMotivation.Ok;
    }
    /**
     * @param {?} coupon
     * @return {?}
     */
    getCouponType(coupon) {
        if (coupon.Groupings.length === 0) {
            return CouponType.Unknown;
        }
        /** @type {?} */
        const oddsForEventMap = {};
        for (let i = 0; i < coupon.Odds.length; i++) {
            /** @type {?} */
            const odd = coupon.Odds[i];
            if (typeof oddsForEventMap[odd.MatchId] === 'undefined') {
                oddsForEventMap[odd.MatchId] = new Array();
            }
            oddsForEventMap[odd.MatchId].push(odd);
        }
        /** @type {?} */
        const maxGrp = coupon.MaxGrouping();
        /** @type {?} */
        let countCompatible = 0;
        /** @type {?} */
        let countIncompatible = 0;
        for (const key of Object.keys(oddsForEventMap)) {
            /** @type {?} */
            const x = (/** @type {?} */ (oddsForEventMap[key]));
            if (x.filter((/**
             * @param {?} o
             * @return {?}
             */
            o => o.CompatibilityLevel === CompatibilityLevel.CompatibleMarket)).length > 0) {
                countCompatible += 1;
            }
            if (x.filter((/**
             * @param {?} o
             * @return {?}
             */
            o => o.CompatibilityLevel === CompatibilityLevel.IncompatibleMarket)).length > 1) {
                countIncompatible += 1;
            }
        }
        if (countIncompatible > 0) {
            return CouponType.System;
        }
        if (maxGrp === 1) {
            return CouponType.Single;
        }
        if (coupon.Groupings.length === 1 && coupon.Groupings[0].Grouping === maxGrp && countCompatible === 0) {
            return CouponType.Multiple;
        }
        if (coupon.Groupings.filter((/**
         * @param {?} g
         * @return {?}
         */
        g => g.Grouping !== maxGrp)).length > 0 ||
            (coupon.Groupings.length === 1 && coupon.Groupings[0].Grouping === maxGrp && countCompatible > 0)) {
            return CouponType.System;
        }
        return CouponType.Unknown;
    }
}
class BetCouponExtension {
    /**
     * @param {?} correctScoreOddsMatrix
     */
    constructor(correctScoreOddsMatrix) {
        this.couponEvaluator = new CouponEvaluator();
        this.couponCalculation = new CouponCalculation(correctScoreOddsMatrix);
    }
    /**
     * @param {?} betCouponOdd
     * @param {?} betCoupon
     * @param {?} compatibleMarketSelection
     * @param {?} allowSameMatchSelections
     * @return {?}
     */
    addOdd(betCouponOdd, betCoupon, compatibleMarketSelection, allowSameMatchSelections) {
        if (betCoupon.Odds.filter((/**
         * @param {?} o
         * @return {?}
         */
        o => o.SelectionId === betCouponOdd.SelectionId ||
            (betCouponOdd.IncompatibleEvents != null &&
                betCouponOdd.IncompatibleEvents.indexOf(o.MatchId) !== -1 &&
                !(compatibleMarketSelection[betCouponOdd.MarketTypeId] &&
                    compatibleMarketSelection[betCouponOdd.MarketTypeId].indexOf(o.MarketTypeId) !== -1)))).length > 0) {
            return AddOddResult.IncompatibleEvents;
        }
        /** @type {?} */
        const previousMaxGrouping = betCoupon.MaxGrouping();
        /** @type {?} */
        const eventOdds = betCoupon.Odds.filter((/**
         * @param {?} b
         * @return {?}
         */
        b => b.MatchId === betCouponOdd.MatchId));
        /** @type {?} */
        let isCompatible = false;
        /** @type {?} */
        let existsIncompatibleMarket = false;
        betCouponOdd.CompatibilityLevel = CompatibilityLevel.IncompatibleMarket;
        if (eventOdds.length > 0) {
            isCompatible = this.isCouponOddCompatible(betCoupon, betCouponOdd, eventOdds);
            if (isCompatible) {
                // check old Odds in coupon compatibility
                existsIncompatibleMarket =
                    eventOdds.length > 1 && eventOdds.filter((/**
                     * @param {?} e
                     * @return {?}
                     */
                    e => e.CompatibilityLevel === CompatibilityLevel.IncompatibleMarket)).length > 0;
                // set compatibility for new Odd
                betCouponOdd.CompatibilityLevel = existsIncompatibleMarket
                    ? CompatibilityLevel.IncompatibleMarket
                    : CompatibilityLevel.CompatibleMarket;
            }
        }
        if (betCoupon.Odds.length >= 1) {
            if (betCouponOdd.GamePlay === 0) {
                return AddOddResult.CannotInsertUniqueOddError;
            }
            else if (betCoupon.Odds.filter((/**
             * @param {?} o
             * @return {?}
             */
            o => o.GamePlay === 0)).length > 0) {
                return AddOddResult.CouponContainsUniqueOddError;
            }
        }
        if (betCoupon.Odds.length >= betCoupon.BetCouponGlobalVariable.MaxNoOfSelections) {
            return AddOddResult.MaxNoOfSelectionsError;
        }
        if (uniqBy(betCoupon.Odds, 'MatchId').length >= betCoupon.BetCouponGlobalVariable.MaxNoOfEvents &&
            betCoupon.Odds.filter((/**
             * @param {?} o
             * @return {?}
             */
            o => o.MatchId === betCouponOdd.MatchId)).length === 0) {
            return AddOddResult.MaxNoOfEventsError;
        }
        if (eventOdds.filter((/**
         * @param {?} o
         * @return {?}
         */
        o => o.CompatibilityLevel === CompatibilityLevel.IncompatibleMarket)).length >= 1) {
            if (betCouponOdd.Fixed) {
                return AddOddResult.CannotInsertFixedOddOnCrossCombinationError;
            }
            for (let i = 0; i < eventOdds.length; i++) {
                /** @type {?} */
                const couponOdd = eventOdds[i];
                if (couponOdd.Fixed) {
                    couponOdd.Fixed = false;
                }
            }
        }
        if (isCompatible) {
            if (!existsIncompatibleMarket && eventOdds.length === 1) {
                eventOdds[0].CompatibilityLevel = CompatibilityLevel.CompatibleMarket;
            }
        }
        else {
            if (eventOdds.filter((/**
             * @param {?} e
             * @return {?}
             */
            e => e.CompatibilityLevel === CompatibilityLevel.CompatibleMarket)).length > 0) {
                for (let i = 0; i < eventOdds.length; i++) {
                    eventOdds[i].CompatibilityLevel = CompatibilityLevel.IncompatibleMarket;
                }
                betCoupon.Groupings = betCoupon.Groupings.filter((/**
                 * @param {?} g
                 * @return {?}
                 */
                g => g.Grouping <= betCoupon.MaxGrouping()));
            }
        }
        if (!allowSameMatchSelections) {
            // If allowSameMatchSelections is set to false and another odd for the same match already
            // exists, replace it while keeping the same index
            /** @type {?} */
            const sameMatchOddIdx = betCoupon.Odds.findIndex((/**
             * @param {?} o
             * @return {?}
             */
            o => o.MatchId === betCouponOdd.MatchId));
            if (sameMatchOddIdx >= 0) {
                betCoupon.Odds.splice(sameMatchOddIdx, 1, betCouponOdd);
            }
            else {
                betCoupon.Odds.push(betCouponOdd);
            }
        }
        else {
            betCoupon.Odds.push(betCouponOdd);
        }
        if (this.followMaxGrouping(betCoupon, previousMaxGrouping)) {
            return AddOddResult.SuccessFollowMutiple;
        }
        betCoupon.CouponTypeId = this.couponEvaluator.getCouponType(betCoupon);
        return AddOddResult.Success;
    }
    /**
     * @param {?} betCoupon
     * @param {?} betCouponOdd
     * @param {?} eventOddsToCheck
     * @return {?}
     */
    isCouponOddCompatible(betCoupon, betCouponOdd, eventOddsToCheck) {
        // marketCompatibilityGroup
        // if (false) {
        // } else {
        if (betCouponOdd.CompatibleMarkets == null || betCouponOdd.CompatibleMarkets.length === 0) {
            return false;
        }
        else {
            /** @type {?} */
            const OddsToCheck = eventOddsToCheck.filter((/**
             * @param {?} o
             * @return {?}
             */
            o => o.SelectionId !== betCouponOdd.SelectionId));
            return OddsToCheck.every((/**
             * @param {?} o
             * @return {?}
             */
            o => betCouponOdd.CompatibleMarkets.indexOf(o.MarketId) !== -1));
        }
        // }
    }
    /**
     * @param {?} betCoupon
     * @param {?} idSelection
     * @return {?}
     */
    removeOdd(betCoupon, idSelection) {
        /** @type {?} */
        const filterOdds = betCoupon.Odds.filter((/**
         * @param {?} o
         * @return {?}
         */
        o => o.SelectionId === idSelection));
        if (filterOdds.length > 0) {
            /** @type {?} */
            const odd = filterOdds[0];
            /** @type {?} */
            const incEvents = betCoupon.Odds.filter((/**
             * @param {?} o
             * @return {?}
             */
            o => o.MatchId === odd.MatchId && o.CompatibilityLevel === CompatibilityLevel.IncompatibleMarket));
            if (odd.CompatibilityLevel === CompatibilityLevel.IncompatibleMarket && incEvents.length > 1) {
                return this.removeOddInternal(betCoupon, odd);
            }
            if (betCoupon.Groupings.length > 0) {
                /** @type {?} */
                const maxGroup = maxBy(betCoupon.Groupings, 'Grouping').Grouping;
                if (remove(betCoupon.Groupings, (/**
                 * @param {?} g
                 * @return {?}
                 */
                g => g.Grouping === maxGroup)).length > 0) {
                    return this.removeOddInternal(betCoupon, odd);
                }
                else {
                    return RemoveOddResult.CannotRemoveGroupingError;
                }
            }
            return this.removeOddInternal(betCoupon, odd);
        }
        else {
            return RemoveOddResult.OddNotExists;
        }
    }
    /**
     * @param {?} betCoupon
     * @param {?} grouping
     * @param {?} combinations
     * @param {?} stake
     * @return {?}
     */
    addGroup(betCoupon, grouping, combinations, stake) {
        /** @type {?} */
        const newGroup = new BetCouponGroup();
        newGroup.Grouping = grouping;
        newGroup.Combinations = combinations;
        newGroup.Stake = stake;
        betCoupon.Groupings.push(newGroup);
        betCoupon.CouponTypeId = this.couponEvaluator.getCouponType(betCoupon);
    }
    /**
     * @param {?} betCoupon
     * @param {?} betCouponGroup
     * @return {?}
     */
    removeGroup(betCoupon, betCouponGroup) {
        remove(betCoupon.Groupings, (/**
         * @param {?} g
         * @return {?}
         */
        g => g.Grouping === betCouponGroup.Grouping));
        betCoupon.CouponTypeId = this.couponEvaluator.getCouponType(betCoupon);
    }
    /**
     * @param {?} betCoupon
     * @return {?}
     */
    getTotalCombinations(betCoupon) {
        if (betCoupon.Groupings.length > 0) {
            return sumBy(betCoupon.Groupings, 'Combinations');
        }
        else {
            return 0;
        }
    }
    /**
     * @param {?} num
     * @return {?}
     */
    truncateLastRoundedDecimalValue(num) {
        /** @type {?} */
        const pointerIdx = num.toString().indexOf('.');
        /** @type {?} */
        const precisionLength = num.toString().substring(pointerIdx + 1).length;
        /** @type {?} */
        const re = new RegExp('^-?\\d+(?:.\\d{0,' + (precisionLength - 1) + '})?');
        return parseFloat(num.toString().match(re)[0]);
    }
    /**
     * @param {?} betCoupon
     * @param {?} updateCouponWithNewValues
     * @return {?}
     */
    setPossibleCouponStake(betCoupon, updateCouponWithNewValues) {
        /** @type {?} */
        const globalVariables = betCoupon.BetCouponGlobalVariable;
        if (globalVariables == null) {
            console.log('setPossibleCouponStake(): This function requires BetCouponGlobalVariable in BetCoupon to verify stake checks.');
            return;
        }
        /** @type {?} */
        const minBetStake = betCoupon.MinBetStake();
        switch (betCoupon.CouponTypeId) {
            case CouponType.Single:
            case CouponType.Unknown:
            default:
                /** @type {?} */
                let tempStakeTaxed = 0;
                if (betCoupon.StakeGross !== 0) {
                    tempStakeTaxed = (betCoupon.StakeGross - betCoupon.Stake) / betCoupon.StakeGross;
                }
                if (globalVariables.StakeMod0Single != null && globalVariables.StakeMod0Single !== 0) {
                    /** @type {?} */
                    const modValue = betCoupon.StakeGross % globalVariables.StakeMod0Single;
                    // if correct then exit
                    if (modValue !== 0) {
                        // new Stake Value
                        /** @type {?} */
                        const divValue = betCoupon.StakeGross / globalVariables.StakeMod0Single;
                        /** @type {?} */
                        let rounded = Math.round(divValue);
                        if (rounded === 0) {
                            rounded = 1;
                        }
                        betCoupon.StakeGross = rounded * globalVariables.StakeMod0Single;
                    }
                }
                if (betCoupon.StakeGross < minBetStake) {
                    betCoupon.StakeGross = minBetStake;
                }
                betCoupon.Stake = betCoupon.StakeGross - betCoupon.StakeGross * tempStakeTaxed;
                for (const grpItem of betCoupon.Groupings) {
                    grpItem.Stake = betCoupon.Stake;
                }
                break;
            case CouponType.Multiple:
                /** @type {?} */
                let tempStakeTaxedMultiple = 0;
                if (betCoupon.StakeGross !== 0) {
                    tempStakeTaxedMultiple = (betCoupon.StakeGross - betCoupon.Stake) / betCoupon.StakeGross;
                }
                if (globalVariables.StakeMod0Multiple != null && globalVariables.StakeMod0Multiple !== 0) {
                    /** @type {?} */
                    const modValueMultiple = betCoupon.StakeGross % globalVariables.StakeMod0Multiple;
                    // if correct then exit
                    if (modValueMultiple !== 0) {
                        // new Stake Value
                        /** @type {?} */
                        const divValueMultiple = betCoupon.StakeGross / globalVariables.StakeMod0Multiple;
                        /** @type {?} */
                        let rounded = Math.round(divValueMultiple);
                        if (rounded === 0) {
                            rounded = 1;
                        }
                        betCoupon.StakeGross = rounded * globalVariables.StakeMod0Multiple;
                    }
                }
                if (betCoupon.StakeGross < minBetStake) {
                    betCoupon.StakeGross = minBetStake;
                }
                betCoupon.Stake = betCoupon.StakeGross - betCoupon.StakeGross * tempStakeTaxedMultiple;
                for (const grpItem of betCoupon.Groupings) {
                    grpItem.Stake = betCoupon.Stake;
                }
                break;
            case CouponType.System:
                for (const grpItem of betCoupon.Groupings) {
                    // get ratio of inner stake to get minStake for grouping allowed
                    /** @type {?} */
                    let minInnerStakeAllowed = globalVariables.MinGroupingsBetStake;
                    if (betCoupon.Stake !== 0) {
                        /** @type {?} */
                        let grpStakeRatio = grpItem.Stake / betCoupon.Stake;
                        grpStakeRatio = this.truncateLastRoundedDecimalValue(grpStakeRatio);
                        minInnerStakeAllowed = Math.max(globalVariables.MinGroupingsBetStake, minBetStake * grpStakeRatio);
                    }
                    if (globalVariables.StakeInnerMod0Combination != null && globalVariables.StakeInnerMod0Combination !== 0) {
                        /** @type {?} */
                        const modValueItem = grpItem.Stake % globalVariables.StakeInnerMod0Combination;
                        // if correct then continue to next GroupItem
                        if (modValueItem !== 0) {
                            // new Stake Value
                            /** @type {?} */
                            const divValueItem = grpItem.Stake / globalVariables.StakeInnerMod0Combination;
                            /** @type {?} */
                            let rounded = Math.round(divValueItem);
                            if (rounded === 0) {
                                rounded = 1;
                            }
                            grpItem.Stake = rounded * globalVariables.StakeInnerMod0Combination;
                        }
                        if (grpItem.Stake < minInnerStakeAllowed) {
                            // new Stake Value
                            /** @type {?} */
                            const divValueItemMin = minInnerStakeAllowed / globalVariables.StakeInnerMod0Combination;
                            /** @type {?} */
                            let roundedMin = Math.ceil(divValueItemMin);
                            if (roundedMin === 0) {
                                roundedMin = 1;
                            }
                            grpItem.Stake = roundedMin * globalVariables.StakeInnerMod0Combination;
                        }
                    }
                }
                break;
        }
        // recalculate coupon to use set stake values if not updateCouponWithNewValues
    }
    /**
     * @param {?} betCoupon
     * @return {?}
     */
    getMinWin(betCoupon) {
        if (betCoupon.Groupings.length > 0) {
            return minBy(betCoupon.Groupings, 'MinWin').MinWin;
        }
        else {
            return 0;
        }
    }
    /**
     * @param {?} betCoupon
     * @return {?}
     */
    getNetStakeMinWin(betCoupon) {
        if (betCoupon.Groupings.length > 0) {
            return minBy(betCoupon.Groupings, 'MinWinNet').MinWin;
        }
        else {
            return 0;
        }
    }
    /**
     * @param {?} betCoupon
     * @return {?}
     */
    getMaxWin(betCoupon) {
        if (betCoupon.Groupings.length > 0) {
            return sumBy(betCoupon.Groupings, 'MaxWin');
        }
        else {
            return 0;
        }
    }
    /**
     * @param {?} betCoupon
     * @return {?}
     */
    getNetStakeMaxWin(betCoupon) {
        if (betCoupon.Groupings.length > 0) {
            return sumBy(betCoupon.Groupings, 'MaxWinNet');
        }
        else {
            return 0;
        }
    }
    /**
     * @param {?} betCoupon
     * @return {?}
     */
    getMinBonus(betCoupon) {
        if (betCoupon.Groupings.length > 0) {
            return minBy(betCoupon.Groupings, 'MinBonus').MinBonus;
        }
        else {
            return 0;
        }
    }
    /**
     * @param {?} betCoupon
     * @return {?}
     */
    getMaxBonus(betCoupon) {
        if (betCoupon.Groupings.length > 0) {
            return sumBy(betCoupon.Groupings, 'MaxBonus');
        }
        else {
            return 0;
        }
    }
    /**
     * @param {?} betCoupon
     * @return {?}
     */
    getMinPercentageBonus(betCoupon) {
        if (betCoupon.Groupings.length > 0) {
            return minBy(betCoupon.Groupings, 'MinPercentageBonus').MinPercentageBonus;
        }
        else {
            return 0;
        }
    }
    /**
     * @param {?} betCoupon
     * @return {?}
     */
    getMaxPercentageBonus(betCoupon) {
        if (betCoupon.Groupings.length > 0) {
            return maxBy(betCoupon.Groupings, 'MaxPercentageBonus').MaxPercentageBonus;
        }
        else {
            return 0;
        }
    }
    /**
     * @param {?} betCoupon
     * @return {?}
     */
    getMinOdd(betCoupon) {
        if (betCoupon.Groupings != null && betCoupon.Groupings.length > 0) {
            /** @type {?} */
            const minWinGroup = betCoupon.Groupings.filter((/**
             * @param {?} g
             * @return {?}
             */
            g => g.Stake > 0)).sort((/**
             * @param {?} a
             * @param {?} b
             * @return {?}
             */
            (a, b) => a.MinWin - b.MinWin))[0];
            if (minWinGroup != null) {
                return parseFloat((minWinGroup.MinWin / minWinGroup.Stake).toFixed(2));
            }
        }
        return 0;
    }
    /**
     * @param {?} betCoupon
     * @return {?}
     */
    getMaxOdd(betCoupon) {
        if (betCoupon.Groupings != null && betCoupon.Groupings.length > 0) {
            /** @type {?} */
            const maxOddSum = betCoupon.Groupings.filter((/**
             * @param {?} g
             * @return {?}
             */
            g => g.Stake > 0)).reduce((/**
             * @param {?} acc
             * @param {?} g
             * @return {?}
             */
            (acc, g) => acc + g.MaxWin / g.Stake), 0);
            return parseFloat(maxOddSum.toFixed(2));
        }
        return 0;
    }
    /**
     * @param {?} betCoupon
     * @param {?} useInnerStake
     * @param {?} bonusList
     * @param {?} brandID
     * @return {?}
     */
    calculateAndUpdate(betCoupon, useInnerStake, bonusList, brandID) {
        /** @type {?} */
        let calculatedCoupon = this.couponCalculation.calcCombinations(betCoupon);
        /** @type {?} */
        const possibleMissingGroupings = new Array();
        for (let i = 0; i < calculatedCoupon.Groups.length; i++) {
            /** @type {?} */
            const calculatedGroup = calculatedCoupon.Groups[i];
            /** @type {?} */
            const combinations = calculatedGroup.Combinations;
            /** @type {?} */
            const betCouponGroups = betCoupon.Groupings.filter((/**
             * @param {?} g
             * @return {?}
             */
            g => g.Grouping === calculatedGroup.Grouping));
            if (betCouponGroups.length > 1) {
                throw new Error('Multiple Groupings defined!');
            }
            // add all groupings
            if (betCouponGroups.length === 0) {
                /** @type {?} */
                const newGroup = new BetCouponGroupMissing();
                newGroup.Grouping = calculatedGroup.Grouping;
                newGroup.Combinations = calculatedGroup.Combinations;
                possibleMissingGroupings.push(newGroup);
            }
            if (combinations <= 0 || combinations > betCoupon.BetCouponGlobalVariable.MaxCouponCombinations) {
                if (betCouponGroups.length > 0) {
                    this.removeGroup(betCoupon, betCouponGroups[0]);
                }
            }
            else {
                if (betCouponGroups.length > 0) {
                    betCouponGroups[0].Combinations = combinations;
                }
            }
        }
        // BTK-1297: ensure there is always 1 group selected if possible
        if (betCoupon.Groupings.length === 0 && possibleMissingGroupings.length >= 1) {
            // find the last available grouping which doesn't have grouping 1 or grouping equal
            // to number of odds in the coupon
            /** @type {?} */
            const validGroupings = possibleMissingGroupings.filter((/**
             * @param {?} g
             * @return {?}
             */
            g => g.Grouping > 0 && g.Grouping !== 1 && g.Grouping !== betCoupon.Odds.length));
            /** @type {?} */
            const lastGrouping = validGroupings.pop();
            if (lastGrouping) {
                // create a new grouping based on the one found
                /** @type {?} */
                const newGrouping = new BetCouponGroup();
                newGrouping.Combinations = lastGrouping.Combinations;
                newGrouping.Grouping = lastGrouping.Grouping;
                betCoupon.Groupings.push(newGrouping);
                // remove the selected grouping from the list of possibleMissingGroupings
                remove(possibleMissingGroupings, (/**
                 * @param {?} g
                 * @return {?}
                 */
                g => g.Grouping === lastGrouping.Grouping && g.Combinations === lastGrouping.Combinations));
            }
        }
        betCoupon.PossibleMissingGroupings = possibleMissingGroupings;
        betCoupon.CouponTypeId = CouponType.Single;
        betCoupon.TotalCombinations = this.getTotalCombinations(betCoupon);
        if (!useInnerStake) {
            /** @type {?} */
            const stakePerCombination = betCoupon.StakeGross / betCoupon.TotalCombinations;
            //// PS: This logic was turned off in task BTK-201
            // if (stakePerCombination < betCoupon.BetCouponGlobalVariable.MinGroupingsBetStake)
            //    stakePerCombination = betCoupon.BetCouponGlobalVariable.MinGroupingsBetStake;
            for (let i = 0; i < betCoupon.Groupings.length; i++) {
                /** @type {?} */
                const betCouponGroup = betCoupon.Groupings[i];
                betCouponGroup.Stake = stakePerCombination;
            }
        }
        // update the CouponTypeId
        betCoupon.CouponTypeId = this.couponEvaluator.getCouponType(betCoupon);
        // calculate the new stake
        /** @type {?} */
        const previousStakeGross = parseFloat(betCoupon.StakeGross.toString());
        /** @type {?} */
        let newStakeGross = 0;
        for (let i = 0; i < betCoupon.Groupings.length; i++) {
            /** @type {?} */
            const betCouponGroup = betCoupon.Groupings[i];
            newStakeGross += betCouponGroup.Stake * betCouponGroup.Combinations;
        }
        if (newStakeGross.toFixed(2) !== previousStakeGross.toFixed(2)) {
            // adjust to possible stake allowed by system.
            this.setPossibleCouponStake(betCoupon, true);
            newStakeGross = 0;
            for (let i = 0; i < betCoupon.Groupings.length; i++) {
                /** @type {?} */
                const betCouponGroup = betCoupon.Groupings[i];
                newStakeGross += betCouponGroup.Stake * betCouponGroup.Combinations;
            }
        }
        betCoupon.StakeGross = newStakeGross;
        calculatedCoupon = this.couponCalculation.calcPotentialWins(betCoupon, bonusList, brandID);
        this.updateFromCalculatedCoupon(betCoupon, calculatedCoupon);
        betCoupon.setAllowFixed();
        betCoupon.setTax(); // Obsolete: Phasing out old tax method
        betCoupon.setStakeTaxed(); // Obsolete: Phasing out old tax method
        betCoupon.setStake();
        betCoupon.setTotalOdds();
        betCoupon.calculateAndSetTaxes(betCoupon, brandID);
        return calculatedCoupon;
    }
    /**
     * @param {?} betCoupon
     * @param {?} calculatedCoupon
     * @return {?}
     */
    updateFromCalculatedCoupon(betCoupon, calculatedCoupon) {
        if (betCoupon.Groupings.length > 0) {
            for (let i = 0; i < calculatedCoupon.Groups.length; i++) {
                /** @type {?} */
                const calculatedGroup = calculatedCoupon.Groups[i];
                /** @type {?} */
                let betCouponGroup;
                /** @type {?} */
                const betCouponGroups = betCoupon.Groupings.filter((/**
                 * @param {?} g
                 * @return {?}
                 */
                g => g.Grouping === calculatedGroup.Grouping));
                if (betCouponGroups.length > 0) {
                    betCouponGroup = betCouponGroups[0];
                    betCouponGroup.Combinations = calculatedGroup.Combinations;
                    betCouponGroup.MaxBonus = calculatedGroup.MaxBonus();
                    betCouponGroup.MaxWin = calculatedGroup.MaxWin();
                    // Till this point only turnover tax is applied. Witholding tax is applied later
                    betCouponGroup.MaxWinNet = calculatedGroup.NetStakeMaxWin();
                    betCouponGroup.NetStakeMaxWin = calculatedGroup.NetStakeMaxWin();
                    betCouponGroup.MinBonus = calculatedGroup.MinBonus();
                    betCouponGroup.MinWin = calculatedGroup.MinWin();
                    // Till this point only turnover tax is applied. Witholding tax is applied later
                    betCouponGroup.MinWinNet = calculatedGroup.NetStakeMinWin();
                    betCouponGroup.NetStakeMinWin = calculatedGroup.NetStakeMinWin();
                    betCouponGroup.MinPercentageBonus = calculatedGroup.MinPercentageBonus;
                    betCouponGroup.MaxPercentageBonus = calculatedGroup.MaxPercentageBonus;
                    betCouponGroup.NetStake = calculatedGroup.StakeForCombinationTaxed;
                }
                if (!this.validate(betCouponGroup)) {
                    this.removeGroup(betCoupon, betCouponGroup);
                }
            }
        }
        // betCoupon.Odds.sortMultipleAsc("EventName", "TournamentName", "MatchName");
        betCoupon.TotalCombinations = this.getTotalCombinations(betCoupon);
        betCoupon.MinWin = this.getMinWin(betCoupon);
        betCoupon.NetStakeMinWin = this.getNetStakeMinWin(betCoupon);
        betCoupon.MaxWin = this.getMaxWin(betCoupon);
        betCoupon.NetStakeMaxWin = this.getNetStakeMaxWin(betCoupon);
        betCoupon.MinBonus = this.getMinBonus(betCoupon);
        betCoupon.MaxBonus = this.getMaxBonus(betCoupon);
        betCoupon.MinPercentageBonus = this.getMinPercentageBonus(betCoupon);
        betCoupon.MaxPercentageBonus = this.getMaxPercentageBonus(betCoupon);
        betCoupon.MinOdd = this.getMinOdd(betCoupon);
        betCoupon.MaxOdd = this.getMaxOdd(betCoupon);
    }
    /**
     * @param {?} betCouponGroup
     * @return {?}
     */
    validate(betCouponGroup) {
        return betCouponGroup.Combinations > 0 && betCouponGroup.Grouping > 0;
    }
    /**
     * @private
     * @param {?} betCoupon
     * @param {?} odd
     * @return {?}
     */
    removeOddInternal(betCoupon, odd) {
        /** @type {?} */
        const previousMaxGrouping = betCoupon.MaxGrouping();
        if (remove(betCoupon.Odds, (/**
         * @param {?} o
         * @return {?}
         */
        o => o.SelectionId === odd.SelectionId)).length > 0) {
            /** @type {?} */
            const eventOdds = betCoupon.Odds.filter((/**
             * @param {?} o
             * @return {?}
             */
            o => o.MatchId === odd.MatchId));
            if (eventOdds.length <= 0) ;
            else if (eventOdds.length === 1) {
                eventOdds[0].CompatibilityLevel = CompatibilityLevel.IncompatibleMarket;
            }
            else {
                for (let i = 0; i < eventOdds.length; i++) {
                    /** @type {?} */
                    const betCouponOdd = eventOdds[i];
                    // const _eventOdds = betCoupon.Odds.filter(o => o.MatchId === betCouponOdd.MatchId);
                    /** @type {?} */
                    const newBetCouponOddCompatibilityLevel = CompatibilityLevel.IncompatibleMarket;
                    // if (eventOdds.length > 0) {
                    // const e = _eventOdds.filter(o => o.CompatibilityLevel === CompatibilityLevel.CompatibleMarket);
                    // if (e.length > 0) {
                    // const compatibleMarketList = e.unique('MarketId');
                    // var isCompatible = eventOdds.every(o => o.
                    // }
                    // }
                    betCouponOdd.CompatibilityLevel = newBetCouponOddCompatibilityLevel;
                }
            }
            if (this.followMaxGrouping(betCoupon, previousMaxGrouping)) {
                return RemoveOddResult.SuccessFollowMutiple;
            }
            betCoupon.CouponTypeId = this.couponEvaluator.getCouponType(betCoupon);
            return RemoveOddResult.Success;
        }
        return RemoveOddResult.CannotRemoveOddError;
    }
    /**
     * @private
     * @param {?} betCoupon
     * @param {?} previousMaxGrouping
     * @return {?}
     */
    followMaxGrouping(betCoupon, previousMaxGrouping) {
        if (previousMaxGrouping === betCoupon.MaxGrouping()) {
            return false;
        }
        if (betCoupon.Odds.length === 0) {
            betCoupon.Groupings = new Array();
            return false;
        }
        if (betCoupon.Groupings.length === 0 || (betCoupon.Groupings.length === 1 && betCoupon.Groupings[0].Grouping === previousMaxGrouping)) {
            betCoupon.Groupings = new Array();
            this.addGroup(betCoupon, betCoupon.MaxGrouping(), 0, 0);
            return true;
        }
        return false;
    }
}
class CouponBuilder {
    /**
     * @param {?} brandID
     * @param {?} bonusList
     * @param {?} globalVariables
     * @param {?} marketExceptionsList
     * @param {?=} correctScoreOddsMatrix
     * @param {?=} allowSameMatchSelections
     */
    constructor(brandID, bonusList, globalVariables, marketExceptionsList, correctScoreOddsMatrix = new StringDictionary(), allowSameMatchSelections) {
        this.brandID = brandID;
        this.bonusList = bonusList;
        this.globalVariables = globalVariables;
        this.marketExceptionsList = marketExceptionsList;
        this.correctScoreOddsMatrix = correctScoreOddsMatrix;
        this.allowSameMatchSelections = allowSameMatchSelections;
        this.couponEvaluator = new CouponEvaluator();
        this.responseStatusHelper = new ResponseStatusHelper();
        this.betCouponExtension = new BetCouponExtension(this.correctScoreOddsMatrix);
    }
    /**
     * @param {?} coupon
     * @return {?}
     */
    updateCoupon(coupon) {
        /** @type {?} */
        const betCoupon = this.convertBetCoupon(coupon);
        /** @type {?} */
        const responseStatus = this.updateBetCoupon(betCoupon, coupon.UseGroupsStake);
        return new BetCouponResponse(responseStatus, betCoupon);
    }
    /**
     * @param {?} s
     * @param {?} coupon
     * @return {?}
     */
    removeSelection(s, coupon) {
        /** @type {?} */
        const betCoupon = this.convertBetCoupon(coupon);
        /** @type {?} */
        const betCouponOdd = new BetCouponOdd(s);
        /** @type {?} */
        const responseStatus = this.removeCouponOdd(betCoupon, betCouponOdd.SelectionId, betCoupon.UseGroupsStake);
        return new BetCouponResponse(responseStatus, betCoupon);
    }
    /**
     * @param {?} s
     * @param {?=} language
     * @return {?}
     */
    addSelection(s, language = 'en') {
        /** @type {?} */
        const betCoupon = new BetCoupon(this.globalVariables);
        betCoupon.Language = language;
        /** @type {?} */
        const betCouponOdd = new BetCouponOdd(s);
        /** @type {?} */
        const responseStatus = this.getCouponOdd(betCoupon, betCouponOdd, false);
        return new BetCouponResponse(responseStatus, betCoupon);
    }
    /**
     * @param {?} s
     * @param {?} coupon
     * @return {?}
     */
    addSelectionToCoupon(s, coupon) {
        /** @type {?} */
        const betCoupon = this.convertBetCoupon(coupon);
        /** @type {?} */
        const betCouponOdd = new BetCouponOdd(s);
        /** @type {?} */
        const responseStatus = this.getCouponOdd(betCoupon, betCouponOdd, betCoupon.UseGroupsStake);
        return new BetCouponResponse(responseStatus, betCoupon);
    }
    /**
     * @private
     * @param {?} coupon
     * @return {?}
     */
    convertBetCoupon(coupon) {
        // if (!coupon.IsClientSideCoupon) {
        /** @type {?} */
        const betCoupon = extend(new BetCoupon(this.globalVariables), coupon);
        return betCoupon;
        // } else
        //    return coupon;
    }
    /**
     * @private
     * @param {?} betCoupon
     * @param {?} betCouponOdd
     * @param {?} useInnerStake
     * @return {?}
     */
    getCouponOdd(betCoupon, betCouponOdd, useInnerStake) {
        betCoupon.BetCouponGlobalVariable = this.globalVariables;
        /** @type {?} */
        const addOddStatus = this.responseStatusHelper.convertAddOddResult(this.betCouponExtension.addOdd(betCouponOdd, betCoupon, this.marketExceptionsList, this.allowSameMatchSelections));
        /** @type {?} */
        const updateStatus = this.updateBetCoupon(betCoupon, useInnerStake);
        return addOddStatus === ResponseStatus.Success ? updateStatus : addOddStatus;
    }
    /**
     * @private
     * @param {?} betCoupon
     * @param {?} idSelection
     * @param {?} useInnerStake
     * @return {?}
     */
    removeCouponOdd(betCoupon, idSelection, useInnerStake) {
        /** @type {?} */
        const removeOddStatus = this.responseStatusHelper.convertRemoveOddResult(this.betCouponExtension.removeOdd(betCoupon, idSelection));
        /** @type {?} */
        const updateStatus = this.updateBetCoupon(betCoupon, useInnerStake);
        return removeOddStatus === ResponseStatus.Success ? updateStatus : removeOddStatus;
    }
    /**
     * @private
     * @param {?} betCoupon
     * @param {?} useInnerStake
     * @return {?}
     */
    updateBetCoupon(betCoupon, useInnerStake) {
        this.betCouponExtension.calculateAndUpdate(betCoupon, useInnerStake, this.bonusList, this.brandID);
        betCoupon.CurrentEvalMotivation = this.couponEvaluator.evaluate(betCoupon);
        betCoupon.IsClientSideCoupon = true;
        return this.responseStatusHelper.convertEvaluationMotivation(betCoupon.CurrentEvalMotivation);
    }
}
class SelectionCompatibilityMatrixEngine {
    /**
     * @param {?} correctScoreOddsMatrix
     */
    constructor(correctScoreOddsMatrix) {
        this.correctScoreOddsMatrix = correctScoreOddsMatrix;
    }
    /**
     * @param {?} odds
     * @return {?}
     */
    Slot(odds) {
        /** @type {?} */
        const result = new Dictionary();
        /** @type {?} */
        const partitions = new Dictionary();
        /** @type {?} */
        const selectionCompatibilityMatrix = this.correctScoreOddsMatrix;
        odds.forEach((/**
         * @param {?} o
         * @return {?}
         */
        o => {
            /** @type {?} */
            const marketTypeId = o.MarketTypeId === undefined ? '' : o.MarketTypeId;
            /** @type {?} */
            const idSelectionType = o.IDSelectionType === undefined ? '' : o.IDSelectionType;
            /** @type {?} */
            const specialValue = o.SpecialValue === undefined ? '' : o.SpecialValue;
            /** @type {?} */
            const key = `${marketTypeId}_${idSelectionType}_${specialValue}`;
            if (selectionCompatibilityMatrix[key]) {
                selectionCompatibilityMatrix[key].forEach((/**
                 * @param {?} x
                 * @return {?}
                 */
                x => this.BuildPartitionOdd(partitions, o.MatchId, x, o)));
            }
            else {
                this.BuildPartitionOdd(partitions, o.MatchId, key, o);
            }
        }));
        partitions.keys().forEach((/**
         * @param {?} k
         * @return {?}
         */
        k => {
            /** @type {?} */
            const c = orderBy(partitions[k].values(), 'MaxOdd', 'desc')[0];
            c.MinOdd = orderBy(partitions[k].values(), 'MaxOdd', 'asc')[0].MaxOdd;
            result.add(k, c);
        }));
        return result;
    }
    /**
     * @private
     * @param {?} partitions
     * @param {?} idEvent
     * @param {?} s
     * @param {?} v
     * @return {?}
     */
    BuildPartitionOdd(partitions, idEvent, s, v) {
        if (!partitions.containsKey(idEvent)) {
            partitions.add(idEvent, new StringDictionary());
        }
        if (!partitions[idEvent].containsKey(s)) {
            partitions[idEvent].add(s, new PartitionOdd());
        }
        partitions[idEvent][s].CompatibleOdds.push(v);
        partitions[idEvent][s].MaxOdd += v.OddValue;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ClientsideCouponService {
    constructor() { }
    /**
     * @private
     * @param {?} request
     * @return {?}
     */
    generateUpdatedBetCoupon(request) {
        /** @type {?} */
        const updatedBetCoupon = request.coupon ? cloneDeep(request.coupon) : new BetCoupon();
        if (request.action === CouponAction.UpdateStakeValue) {
            updatedBetCoupon.UseGroupsStake = false;
            updatedBetCoupon.StakeGross = request.stakeValue;
        }
        else if (request.action === CouponAction.UpdateGroupings) {
            updatedBetCoupon.UseGroupsStake = false;
            request.groupings.forEach((/**
             * @param {?} grouping
             * @return {?}
             */
            grouping => {
                if (grouping.Selected) {
                    // move grouping from PossibleMissingGroupings to Groupings
                    remove(updatedBetCoupon.PossibleMissingGroupings, (/**
                     * @param {?} pmg
                     * @return {?}
                     */
                    pmg => {
                        return pmg.Grouping === grouping.Grouping && pmg.Combinations === grouping.Combinations;
                    }));
                    updatedBetCoupon.Groupings.push(grouping);
                }
                else {
                    // move grouping from Groupings to PossibleMissingGroupings
                    remove(updatedBetCoupon.Groupings, (/**
                     * @param {?} g
                     * @return {?}
                     */
                    g => {
                        return g.Grouping === grouping.Grouping && g.Combinations === grouping.Combinations;
                    }));
                    /** @type {?} */
                    const possibleMissingGrouping = new BetCouponGroupMissing();
                    possibleMissingGrouping.Grouping = grouping.Grouping;
                    possibleMissingGrouping.Combinations = grouping.Combinations;
                    updatedBetCoupon.PossibleMissingGroupings.push(possibleMissingGrouping);
                }
            }));
        }
        else if (request.action === CouponAction.UpdateGroupingStakeValue) {
            updatedBetCoupon.UseGroupsStake = true;
            // Find the 'Groupings'
            /** @type {?} */
            const grouping = updatedBetCoupon.Groupings.find((/**
             * @param {?} g
             * @return {?}
             */
            g => {
                return g.Grouping === request.groupings[0].Grouping && g.Combinations === request.groupings[0].Combinations;
            }));
            if (grouping == null) {
                // Find the 'Possible Groupings'
                /** @type {?} */
                const possibleGrouping = updatedBetCoupon.PossibleMissingGroupings.find((/**
                 * @param {?} pmg
                 * @return {?}
                 */
                pmg => {
                    return pmg.Grouping === request.groupings[0].Grouping && pmg.Combinations === request.groupings[0].Combinations;
                }));
                /** @type {?} */
                const newGrouping = new BetCouponGroup();
                newGrouping.Grouping = possibleGrouping.Grouping;
                newGrouping.Combinations = possibleGrouping.Combinations;
                newGrouping.Stake = request.groupingStakeValue;
                // Add the found 'PossibleGrouping' PLUS GroupingStake to 'Groupings'
                updatedBetCoupon.Groupings.push(newGrouping);
            }
            else {
                grouping.Stake = request.groupingStakeValue;
            }
        }
        else if (request.action === CouponAction.UpdateOddBankerStatus) {
            /** @type {?} */
            const selectionOdd = updatedBetCoupon.Odds.find((/**
             * @param {?} o
             * @return {?}
             */
            o => o.SelectionId === request.selection.oddId));
            if (selectionOdd) {
                selectionOdd.Fixed = request.isBanker;
            }
        }
        else if (request.action === CouponAction.ClearAllBankers) {
            updatedBetCoupon.Odds.forEach((/**
             * @param {?} o
             * @return {?}
             */
            o => (o.Fixed = false)));
        }
        return updatedBetCoupon;
    }
    /**
     * @private
     * @param {?} request
     * @param {?} updatedBetCoupon
     * @return {?}
     */
    processUpdates(request, updatedBetCoupon) {
        /** @type {?} */
        const couponBuilder = new CouponBuilder(request.brandID, request.bonusList, request.globalVariables, request.marketExceptions, request.correctScoreOddsMatrix, request.allowSameMatchSelections);
        switch (request.action) {
            case CouponAction.AddOdd:
                if (request.coupon == null) {
                    return couponBuilder.addSelection(request.selection, 'en');
                }
                return couponBuilder.addSelectionToCoupon(request.selection, updatedBetCoupon);
            case CouponAction.RemoveOdd:
                return couponBuilder.removeSelection(request.selection, updatedBetCoupon);
            default:
                return couponBuilder.updateCoupon(updatedBetCoupon);
        }
    }
    /**
     * @param {?} betCoupon
     * @return {?}
     */
    formatCoupon(betCoupon) {
        /** @type {?} */
        const coupon = cloneDeep(betCoupon);
        coupon.IsLive = false;
        coupon.HasLive = false;
        if (coupon.Odds.findIndex((/**
         * @param {?} o
         * @return {?}
         */
        o => o.EventCategory === 'L')) > -1) {
            coupon.IsLive = true;
            coupon.HasLive = true;
        }
        // set coupon type
        /** @type {?} */
        const couponTypeId = coupon.CouponTypeId;
        if (couponTypeId === 1) {
            coupon.CouponType = CouponType.Single;
        }
        else if (couponTypeId === 2) {
            coupon.CouponType = CouponType.Multiple;
        }
        else if (couponTypeId === 3) {
            coupon.CouponType = CouponType.System;
        }
        // Sort groupings and possible groupings and add them together
        /** @type {?} */
        const allGroupingsArray = new Array();
        coupon.PossibleMissingGroupings.forEach((/**
         * @param {?} pmg
         * @return {?}
         */
        pmg => {
            if (pmg.Combinations > -1) {
                /** @type {?} */
                const newGrouping = new BetCouponGroup();
                newGrouping.Grouping = pmg.Grouping;
                newGrouping.Combinations = pmg.Combinations;
                allGroupingsArray.push(newGrouping);
            }
        }));
        coupon.Groupings.forEach((/**
         * @param {?} g
         * @return {?}
         */
        g => {
            if (g.Combinations <= -1) {
                return;
            }
            g.Stake = floor(g.Stake, 2);
            g.Selected = false;
            if (g.Stake > -1) {
                g.Selected = true;
            }
            allGroupingsArray.push(g);
        }));
        coupon.AllGroupings = sortBy(allGroupingsArray, ['Grouping']);
        return coupon;
    }
    /**
     * @param {?} request
     * @return {?}
     */
    updateCoupon(request) {
        /** @type {?} */
        const updatedBetCoupon = this.generateUpdatedBetCoupon(request);
        if (request.action !== CouponAction.AddOdd && updatedBetCoupon.Odds.length <= 0) {
            return new UpdateCouponResponse({
                success: false,
                updatedCoupon: null,
                statusCode: ResponseStatus.Error,
                message: 'Coupon is empty'
            });
        }
        /** @type {?} */
        const response = this.processUpdates(request, updatedBetCoupon);
        /** @type {?} */
        const updatedCoupon = this.formatCoupon(response.BetCoupon);
        if (response.ResponseStatus !== ResponseStatus.Success) {
            return new UpdateCouponResponse({
                success: false,
                updatedCoupon: updatedCoupon,
                statusCode: response.ResponseStatus,
                message: response.ResponseMessage
            });
        }
        return new UpdateCouponResponse({
            success: true,
            updatedCoupon: updatedCoupon,
            statusCode: ResponseStatus.Success
        });
    }
    /**
     * @param {?=} userId
     * @return {?}
     */
    generateTransactionId(userId) {
        /** @type {?} */
        const partOne = new Date()
            .getTime()
            .toString()
            .substring(3);
        /** @type {?} */
        const partTwo = Math.floor(Math.random() * 100 + 1);
        /** @type {?} */
        const partThree = userId || '';
        /** @type {?} */
        let transactionId = `${partOne}${partTwo}${partThree}`;
        if (transactionId.length > 20) {
            transactionId = transactionId.substring(0, 20);
        }
        return transactionId;
    }
}
ClientsideCouponService.ɵfac = function ClientsideCouponService_Factory(t) { return new (t || ClientsideCouponService)(); };
ClientsideCouponService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ClientsideCouponService, factory: ClientsideCouponService.ɵfac, providedIn: 'root' });
/** @nocollapse */
ClientsideCouponService.ctorParameters = () => [];
/** @nocollapse */ ClientsideCouponService.ngInjectableDef = defineInjectable({ factory: function ClientsideCouponService_Factory() { return new ClientsideCouponService(); }, token: ClientsideCouponService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ClientsideCouponService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { BetCoupon, BetCouponGlobalVariable, BetCouponGroup, BetCouponOdd, Bonus, CouponAction, CouponType, MarketTag, Selection, UpdateCouponRequest, UpdateCouponResponse, ClientsideCouponService, Dictionary, StringDictionary };

